import "./T4SlipSetupStyle.css";

import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import {
  DeleteConfirmationDialog,
  EnhancedDropDownRHFWithLabel,
  EnhancedIOSSwitchRHFWithLabel,
  EnhancedSnackbar,
  FieldLayout,
  IEnhancedDropDownItem,
  ITest,
  LabelPosition,
  StandardPanel,
  TwoColumnLayout,
} from "@websential/cosmic";
import {
  EMPLOYEE_RESOURCE_LITERAL,
  GET_QUERY_KEY,
  INITIAL_SNACKBAR_DATA,
  QUERY_OPTIONS,
  T4_SETUP_SCREEN_ID,
  T4_SETUP_SCREEN_SLUG,
} from "../../../common/constants";
import {
  EmployeeAddressSetupFieldsPanel,
  EmployeeInfoSetupFieldsPanel,
  FilingDataSetupFieldsPanel,
  FilteredSelectedOtherInfoT4,
  T4SlipDataPanel,
  applyAdjustment,
  provinceOfEmploymentRes,
  provinceResponce,
  selectedPOE,
} from "./Panels";
import {
  EnhancedDialog,
  EnhancedLinkButton,
  IconTextButton,
  RouterLinkButton,
  SplitButton,
} from "@websential/cosmic";
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { IResponse, IServerError } from "../../../models/common";
import {
  PROVINCE_OF_EMPLOYMENT,
  ProvinceService,
  getPROVINCE_OF_EMPLOYMENT,
} from "../../../services/common/ProvinceService";
import {
  instanceOfIFlexFieldSetupRequest,
  instanceOfIT4SlipResponce,
} from "../../../common/instance-method";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";

import { AdjustmentOptionsService } from "../../../services/AdjustmentOptionsService";
import { Avatar } from "primereact/avatar";
import { BackdropCircularProgress } from "../../../components/BackDrop";
import { Calendar } from "primereact/calendar";
import Card from "@mui/material/Card";
import { ClientService } from "../../../services";
import { DefaultSettingsService } from "../../../services/DefaultSettingsService";
import { Divider } from "primereact/divider";
import { Dropdown } from "primereact/dropdown";
import { FieldWrapper } from "../../../components/FieldWrapper/FieldWrapper";
import FileSaver from "file-saver";
import { FlexFieldService } from "../../../services/FlexFieldService";
import { IAppState } from "../../../store/reducers";
import { ICountryReferenceModel } from "../../../models/country/ICountryReferenceModel";
import { IDropDownListResponse } from "../../../models/common/IDropDownListResponse";
import { IFlexFieldSetupRequest } from "../../../models/flexField/IFlexFieldSetupRequest";
import { IProvinceReferenceModel } from "../../../models/province/IProvinceReferenceModel";
import { IT4SlipRequestPayload } from "../../../models/t4Slip/IT4SlipRequestPayload";
import { InputText } from "primereact/inputtext";
import { InvoiceDialogPanel } from "../T4SlipList/InvoiceDialogPanel";
import NativeSelect from "@mui/material/NativeSelect";
import { PrintingService } from "../../../services/PrintingService";
import { ReportsService } from "../../../services/ReportsService";
import { T4DOBCalendar } from "./T4DOBCalendar";
import { T4OtherInformationService } from "../../../components/OtherInformation/otherInformations";
import { T4SlipService } from "../../../services/T4SlipService";
import { T4SlipSetupToolbar } from "./T4SlipSetupToolbar";
import { T4SlipSetupValidationSchema } from "./validator";
import { TaxSlipSettingsService } from "../../../services/TaxSlipSettingsService";
import { format } from "date-fns";
import { selectedT4SummaryReduceEIType } from "../T4SlipSummaryReducedEISetup";
import { selectedT4SummaryType } from "../T4SlipSummarySetup";
import { setSelectedActivityLogActions } from "../../../store/actions/activityLogActions";
import { setSelectedINVOICE } from "../../../store/actions";
import { setSelectedStickyNavBar } from "../../../store/actions/stickyNavBarActions";
import { useGetResourceDDLData } from "../../../hooks/useResources";
import { yupResolver } from "@hookform/resolvers/yup";

// import { ResourceService } from "services/ResourceService";


export let fileeeee: any = undefined;
export let checkboxDefaultSelect: any = false;


























// import { Card } from "primereact/card";













export let selectedSlipTypee: any = 400;
export interface IT4SlipSetup extends ITest { }
const SINGLE_RECORD_DATA_QUERY_KEY = "t4-slips-single-data-record";
const SINGLE_Employee_DATA_QUERY_KEY = "employee-data";
// const ADJUSTMENT_DATA_QUERY_KEY = "adjusted-data";
// const DEFAULT_SETTINGS_DATA_QUERY_KEY = "default-settings-data-record";
const EMPLOYEE_DDL_DATA_QUERY_KEY = "employee-ddl-data-record";


const useGetEmployeeDDLItems = (clientId: string, dataRole: string, taxYear: number) =>
  useQuery({
    queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId, dataRole, taxYear],
    queryFn: (data) => {
      return T4SlipService.getEmployeeDDL(clientId, dataRole, taxYear);
    },
    refetchOnWindowFocus: false,
  });

const useGetData = (
  id: string | undefined,
  clientId: string,
  taxYear: number
) =>
  useQuery({
    queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, id],
    queryFn: (data) => {
      return T4SlipService.getT4SlipById(id, clientId, taxYear);
    },
    refetchOnWindowFocus: false
  });

// const useGetGlobalVariables = (taxYear: number) =>
//   useQuery({
//     queryKey: [GET_QUERY_KEY.GET_GLOBAL_VARIABLES_BY_YEAR, taxYear],
//     queryFn: (data) => {
//       return TaxSlipSettingsService.getGlobalVariables(taxYear);
//     },
//     refetchOnWindowFocus: false
//   });

// const useGetSlipRecord = (
//   slipId: string,
//   clientId: string,
//   taxYear: number
// ) =>
//   useQuery({
//     queryKey: [GET_QUERY_KEY.EMPLOYEE_RESOURCE_SLIP_DETAIL, slipId],
//     queryFn: () => { return T4SlipService.getById(slipId, clientId, taxYear) },
//     refetchOnWindowFocus: false, enabled: false
//   });


// const useGetResourceSlips = (
//   resourceId: string,
//   clientId: string,
//   taxYear: number
// ) => useQuery({
//   queryKey: [GET_QUERY_KEY.EMPLOYEE_RESOURCE_SLIPS_DDL, resourceId],
//   queryFn: () => { return T4SlipService.getResourceSlipDropDownList(resourceId, clientId, taxYear) },
//   refetchOnWindowFocus: false, enabled: false
// });


const useGetResourceInformationById = (
  resourceId: string,
  clientId: string,
  roleName: string
) => useQuery({
  queryKey: [SINGLE_Employee_DATA_QUERY_KEY, resourceId, clientId, roleName],
  queryFn: () => { return T4SlipService.getResourceInformationById(resourceId, clientId, roleName) },
  refetchOnWindowFocus: false
});


// const useGetDefaultSettingsData = (
//   clientId: string,
// ) =>
//   useQuery({
//     queryKey: [DEFAULT_SETTINGS_DATA_QUERY_KEY, clientId],
//     queryFn: (data) => {
//       return DefaultSettingsService.getDefaultSettings(clientId);
//     },
//     refetchOnWindowFocus: false
//   });

// const useGetDropDownList = (clientId: string) =>
//   useQuery(
//     GET_QUERY_KEY.EMPLOYEE_RESOURCE_DDL,
//     () => ResourceService.getDropDownList(clientId, "Employee"),
//     QUERY_OPTIONS
//   );

const parseJSONLikeString = (str: string) => {
  // Use regular expressions to add double quotes around keys and string values
  const modifiedString = str.replace(/(\w+):/g, '"$1":').replace(/'/g, '"');

  // Convert the modified JSON string to an object using JSON.parse()
  return JSON.parse(modifiedString);
};


// const useGetSlipIds = (
//   tag: string,
//   clientId: string,
//   taxYear: number
// ) =>
//   useQuery({
//     queryKey: ["get-slip-ids", tag, clientId, taxYear],
//     queryFn: (data) => {
//       return T4SlipService.getSlipIds(tag, clientId, taxYear);
//     },
//     refetchOnWindowFocus: false
//   });

// const useGetCompanyData = (id: string | undefined) =>
//   useQuery({
//     queryKey: ["client-get-by-id", id],
//     queryFn: (data) => {
//       return ClientService.getById(id);
//     },
//     refetchOnWindowFocus: false
//   });

// const T4_SUMMARY_DATA_QUERY_KEY = "get-t4-summary-data";
// const T4_SUMMARY_REDUCED_EI_DATA_QUERY_KEY = "get-t4-summary-reduce-ei-data";
// const useGetT4SummaryData = (
//   clientid: string,
//   slipType: string | number,
//   taxYear: number) =>
//   useQuery({
//     queryKey: [T4_SUMMARY_DATA_QUERY_KEY, clientid, slipType, taxYear],
//     queryFn: (data) => {
//       return T4SlipService.getT4Summary(clientid, slipType, taxYear);
//     },
//     refetchOnWindowFocus: false
//   });

// const useGetT4SummaryReduceEIData = (
//   clientid: string,
//   slipType: string | number,
//   taxYear: number) =>
//   useQuery({
//     queryKey: [T4_SUMMARY_REDUCED_EI_DATA_QUERY_KEY, clientid, slipType, taxYear],
//     queryFn: (data) => {
//       return T4SlipService.getT4SummaryReduceEI(clientid, slipType, taxYear);
//     },
//     refetchOnWindowFocus: false
//   });

export const T4SlipSetup: FC<IT4SlipSetup> = ({ testId }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const clientName = useSelector((state: IAppState) => state.client.clientName);
  const isLoadingActivityLogData = useSelector(
    (state: IAppState) => state.isLoadAxiosCall.isLoading
  );
  const dashboardApiData = useSelector((state: IAppState) => state.dashboardApisData);

  const [snackbarData, setSnackbarData] = useState<any>(INITIAL_SNACKBAR_DATA);
  const clientId = useSelector((state: IAppState) => state.client.id);
  const taxYear = useSelector((state: IAppState) => state.taxYear.year);
  const [adjustment, setAdjustment] = useState(false);
  const [isLoadingAdjustedData, setIsLoadingAdjustedData] = useState(false);
  const [isLoadingSlipListDDL, setIsLoadingSlipListDDL] = useState(false);
  const [selectedResourceId, setSelectedResourceId] = useState("");
  const [selectedResource, setSelectedResource] = useState("create-new");
  const [showbox17IfQC, setShowbox17IfQC] = useState(false);
  const [selectedResourceSlip, setSelectedResourceSlip] =
    useState("create-new");
  const [selectedResourceSlipList, setSelectedResourceSlipList] = useState<
    IDropDownListResponse[]
  >([{ label: "Create New", value: "create-new" }]);

  const [selectedResourceList, setSelectedResourceList] = useState<
    IDropDownListResponse[]
  >([{ label: "Create New", value: "create-new" }]);
  const [resourceListWithoutCreateNew, setResourceListWithoutCreateNew] =
    useState<any>(undefined);
  const [openInvoiceDialog, setInvoiceDialogOpen] = useState(false);
  const [invoiceData, setInvoiceData] = useState<any>([]);
  const [isLoadingDataa, setIsLoadingData] = useState(false);

  const [onResourceSelectionAPIsCalls, setOnResourceSelectionAPIsCalls] =
    useState(false);

  const [editedResourceId, setEditedResourceId] = useState("");
  // const [newCreatedSlipId, setNewCreatedSlipId] = useState('');
  // const [newCreatedResourceId, setNewCreatedResourceId] = useState('');
  const [selectedOtherInformation, setSelectedOtherInformation] =
    useState(false);
  const [oiInEdit, setOiInEdit] = useState(false);
  // const [editedRecordSlipCreateNew, setEditedRecordSlipCreateNew] = useState(false);

  // for delete row
  const [openDialog, setDialogOpen] = useState(false);
  const [apiAction, setApiAction] = useState("");
  const [singleDelete, setSingleDelete] = useState<boolean>(false);
  const [t4SlipId, setT4SlipId] = useState<any>("");
  const [selectedProvinceOfEmployment, setSelectedProvinceOfEmployment] =
    useState("");
  const [selectedCard, setSelectedCard] = useState<any>(null);
  const [itemSearch, setItemSearch] = useState("");
  const [sidePanelsVisibility, setSidePanelsVisibility] = useState(true);

  //one state which store both new cretaed and edited slip data
  const [T4SlipRecord, setT4SlipRecord] = useState<any>(undefined);
  // when  I setValue of otherinformation inside async calls method then facing issue while click on add more so we have to use state method to show otherinformation 
  const [slipOtherInformation, setSlipOtherInformation] =
    useState<any>([]);

  const [invoicePaymentFor, setInvoicePaymentFor] = useState(10)
  // let T4SlipRecord = undefined

  // const queryClient = useQueryClient();


  // const [selectedProvince, setSelectedProvince] =
  //   useState<IProvinceReferenceModel>({
  //     id: null,
  //     name: "",
  //     shortCode: "",
  //   });

  const [CountryResponse] = useState<ICountryReferenceModel>({
    id: 1,
    name: "Canada",
    shortCode: "CAN",
  });

  const [dateOfBirth, setDateOfBirth] = useState<any>("");



  // for edit
  const queryClient = useQueryClient();
  const { id } = useParams();

  let notStartedSlipId = "";
  let completedSlipId = "";
  if (id !== undefined && onResourceSelectionAPIsCalls === false) {
    if (id?.length > 24) {
      notStartedSlipId = id;
    }
    if (id?.length === 24) {
      completedSlipId = id;
    }
  }


  const DEFAULT_VALUES = {
    clientId: clientId,
    taxYear: taxYear,
    // id: null,
    // applyAdjustments:false,
    // saveAdjutments:false,
    // reflectMasterData:false,
    // slipType:100,
    // slipStatus:100,
    // pensionablePeriod:0,
    // otherInformation:{
    //   code:'',
    //   label:'',
    //   amount:0
    // },
    // resource:{
    //   externalId: null,
    // firstName: '',
    // initials: '',
    // lastName: '',
    // dateOfBirth: '01-01-2000',
    // socialInsuranceNumber: '',
    // address: '',
    // city: '',
    // province: {
    //   id:undefined,
    //   name:'',
    //   shortCode:''
    // },
    // country: {
    //   id:undefined,
    //   name:'',
    //   shortCode:''
    // },
    // postCode:'',
    // provinceOfEmployment: {
    //   id:undefined,
    //   name:'',
    //   shortCode:''
    // },
    // email: '',
    // employeeCode: 0,
    // cppQppExempt: false,
    // eiExempt: false,
    // ppipExempt: false,
    // employmentCode: 11,
    // payPeriod: 1,
    // reducedEi: false
    // },
    // overRemittance:0,
    slipData: {
      employmentIncome: "0.00",
      cppContributions: "0.00",
      qppContributions: "0.00",
      eiPremiums: "0.00",
      rppContributions: "0.00",
      incomeTaxDeducted: "0.00",
      eiInsurableEarnings: "0.00",
      cppQppPensionableEarnings: "0.00",
      unionDues: "0.00",
      charitableDonations: "0.00",
      registrationNumber: undefined,
      pensionAdjustment: "0.00",
      ppipPremiums: "0.00",
      ppipInsurableEarnings: "0.00",
    },
    adjustedSlipData: {
      employmentIncome: "0.00",
      cppContributions: "0.00",
      qppContributions: "0.00",
      eiPremiums: "0.00",
      incomeTaxDeducted: "0.00",
      eiInsurableEarnings: "0.00",
      ppipPremiums: "0.00",
      ppipInsurableEarnings: "0.00",
    },
  };

  const formMethods = useForm<any>({
    resolver: yupResolver(T4SlipSetupValidationSchema),
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: DEFAULT_VALUES,
  });


  // Function to sort the data array by the label field
  // sort side cards items 
  const sortData = (data: IDropDownListResponse[]): IDropDownListResponse[] => {
    return data.sort((a, b) => a.label.localeCompare(b.label));
  };

  const { isPending: isSubmitting, mutate: submitFlexFields } = useMutation({
    mutationFn: T4SlipService.create,

    onSuccess: (
      res: IT4SlipRequestPayload | IServerError | IResponse | any
    ) => {

      if (res.data && instanceOfIT4SlipResponce(res.data)) {
        // remove the cache of the flex fields since we just added a new field.
        // queryClient.invalidateQueries(LIST_FIELDS_QUERY_KEY);
        // // [corner case] remove the cache of the field that has just been edited in-case the user re-selects it again
        // queryClient.invalidateQueries([FLEX_FIELD_DATA_QUERY_KEY, res.id]);
        // set the currently added/edited flex field as the selected field

        // commented bcs of ei insuarable earning value issue if i set 50k then if unmask data dost show saved 50k value
        queryClient.invalidateQueries({ queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, res.data.id] });

        formMethods.setValue("id", res.data.id);
        setSnackbarData({
          open: true,
          message: "Data has been submitted successfully!",
          severity: "success",
        });
        // refectchT4SlipIds()

        if (res.status === 201 && selectedResourceSlip === "create-new") {
          (async () => {
            try {

              const response: any =
                await T4SlipService.getResourceSlipDropDownList(
                  res.data?.resource?.externalId,
                  clientId,
                  taxYear
                );
              if (response && Array.isArray(response)) {
                let resourceSlipList: IDropDownListResponse[] =
                  response.map((resourceSlip: IDropDownListResponse) => ({
                    label: resourceSlip.label,
                    value: resourceSlip.value,
                  }));

                resourceSlipList.unshift({
                  label: "Create New",
                  value: "create-new",
                });


                setSelectedResourceSlipList(resourceSlipList);
                formMethods.setValue(
                  "selectedSlip",
                  res.data.id
                );
                let path = `/taxslip/t4/setup/${res.data.id}`;
                navigate(path);
              }
            } catch (error) {
              console.error("Error fetching data:", error);
            }
          })();
          setOnResourceSelectionAPIsCalls(true)
          setSelectedResourceSlip(res.data.id)
        }
      } else {
        setSnackbarData({
          open: true,
          message: res.message ? res.message : res.data.message,
          severity: "error",
        });
      }
      queryClient.invalidateQueries({
        queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId, EMPLOYEE_RESOURCE_LITERAL, taxYear],
      });
      setSelectedCard(String(res.data.resource.externalId));
      formMethods.setValue(
        "selectedEmployee",
        res.data.resource.externalId
      );
      setSelectedResource(res.data.resource.externalId);
      //load slip Data
      if (res && res.data && res.data?.resource) {
        setT4SlipRecord(res.data);
        setSelectedResource(res.data?.resource?.externalId);
      }
      selectedSlipTypee = formMethods.getValues("slipType");
      setSelectedOtherInformation(true);
    },
    onError: (err: any) => {
      setSnackbarData({
        open: true,
        // message: "Something went wrong, try again later!",
        message: err.message,
        severity: "error",
      });
    },
  }
  );
  const [isPendingSlipData, setIsPendingSlipData] = useState(false);

  //when cretae-new seleted from slip ddl
  const createNewActionFromSlipDDL = () => {
    setSelectedOtherInformation(false);
    setT4SlipRecord(undefined);
    setSelectedResourceSlip("create-new");
    formMethods.setValue("selectedSlip", "create-new");
    formMethods.setValue("applyAdjustments", false);
    formMethods.setValue("employmentIncome", "0.00");
    formMethods.setValue("cppContributions", "0.00");
    formMethods.setValue("secondCppContributions", "0.00");
    formMethods.setValue("qppContributions", "0.00");
    formMethods.setValue("secondQppContributions", "0.00");
    formMethods.setValue("eiPremiums", "0.00");
    formMethods.setValue("rppContributions", "0.00");
    formMethods.setValue("incomeTaxDeducted", "0.00");
    formMethods.setValue("eiInsurableEarnings", "0.00");
    formMethods.setValue("cppQppPensionableEarnings", "0.00");
    formMethods.setValue("unionDues", "0.00");
    formMethods.setValue("charitableDonations", "0.00");
    formMethods.setValue("registrationNumber", undefined);
    formMethods.setValue("pensionAdjustment", "0.00");
    formMethods.setValue("ppipPremiums", "0.00");
    formMethods.setValue("ppipInsurableEarnings", "0.00");
    formMethods.setValue("employmentIncomeAdjusted", "0.00");
    formMethods.setValue("cppContributionsAdjusted", "0.00");
    formMethods.setValue("secondCppContributionsAdjusted", "0.00");
    formMethods.setValue("eiPremiumsAdjusted", "0.00");
    formMethods.setValue("incomeTaxDeductedAdjusted", "0.00");
    formMethods.setValue("eiInsurableEarningsAdjusted", "0.00");
    formMethods.setValue("ppipPremiumsAdjusted", "0.00");
    formMethods.setValue("ppipInsurableEarningsAdjusted", 0);
    formMethods.setValue("slipStatus", 200);
    formMethods.setValue("comparison", [{ amount: 0, code: "", label: "" }]);
    // setSlipOtherInformation([])
    // formMethods.setValue("comparison", []);
    setSlipOtherInformation([{ amount: 0, code: 'null', label: 'Empty Field' }])
  };

  const resourceDataByIdPass = useCallback(
    (resourceDataById: any) => {
      setIsPendingSlipData(true);
      if (resourceDataById) {
        Object.keys(resourceDataById).forEach((fieldName) => {
          // @ts-ignore
          const fieldValue = resourceDataById[fieldName];

          formMethods.setValue(
            fieldName,
            fieldValue !== null && fieldValue !== "" ? fieldValue : ""
          );

          if (fieldName === "address") {
            Object.keys(fieldValue).forEach((resourceFieldName) => {
              const resourceFieldValue = fieldValue[resourceFieldName];
              // @ts-ignore

              Object.keys(resourceFieldValue).forEach((resourceFieldNameNew) => {
                const resourceFieldValueNew =
                  resourceFieldValue[resourceFieldNameNew];
                // @ts-ignore

                formMethods.setValue(resourceFieldNameNew, resourceFieldValueNew);

                if (resourceFieldNameNew === "country") {
                  formMethods.setValue(
                    resourceFieldNameNew,
                    resourceFieldValueNew.name ?? undefined
                  );
                }
                if (resourceFieldNameNew === "province") {
                  let id = resourceFieldValueNew.id;
                  let name = resourceFieldValueNew.name;
                  let shortCode = resourceFieldValueNew.shortCode;



                  formMethods.setValue(
                    resourceFieldNameNew,
                    `{id:${id}, name: "${name}",shortCode:"${shortCode}"}`
                    // '{id:1, name: "Alberta",shortCode:"AB"}'
                  );
                }
              });
            });
          }
          if (fieldName === "email") {
            if (fieldValue !== null) {
              formMethods.setValue(fieldName, fieldValue);
            } else {
              // const maskedStatus: any = sessionStorage.getItem("maskEnabled");
              if (dashboardApiData.masked_status) {
                formMethods.setValue(fieldName, "ze*****3@gmail.com");
              } else {
                formMethods.setValue(fieldName, "");
              }
            }
          }
          if (fieldName === "id" && onResourceSelectionAPIsCalls === false) {
            //for auto selected card
            setSelectedCard(String(fieldValue));
            formMethods.setValue(
              "selectedEmployee",
              fieldValue
            );
            setSelectedResource(fieldValue);
          }
          if (fieldName === "metaFields") {
            fieldValue.forEach((obj: any) => {
              formMethods.setValue(obj.name, obj.value);
              if (obj.name === "initial" || obj.name === "INITIALS") {
                formMethods.setValue("initials", obj.value);
              }
              if (obj.name === "employee_code") {
                formMethods.setValue("employeeCode", obj.value);
              }
              if (obj.name === "pay_period") {
                formMethods.setValue("payPeriod", obj.value);
                formMethods.setValue("pensionablePeriod", obj.value);
              }
              if (obj.name === "province_of_employment") {
                getPROVINCE_OF_EMPLOYMENT(obj.value);

                if (PROVINCE_OF_EMPLOYMENT !== "") {
                  formMethods.setValue(
                    "provinceOfEmployment",
                    PROVINCE_OF_EMPLOYMENT
                  );
                }

                if (obj.value === 11) {
                  setShowbox17IfQC(true);
                  setSelectedProvinceOfEmployment("Quebec");
                } else {
                  setShowbox17IfQC(false);
                  setSelectedProvinceOfEmployment(obj.name);

                }
              }
              if (obj.name === "reduced_ei") {
                if (obj.value === false) {
                  formMethods.setValue("reducedEi", 0);
                } else if (obj.value === true) {
                  formMethods.setValue("reducedEi", 1);
                }
              }
              if (obj.name === "date_of_birth") {
                if (obj.value !== "") {
                  formMethods.setValue("dateOfBirth", obj.value);
                  if (obj.value.charAt(2) === "*") {
                    formMethods.setValue("dateOfBirth", obj.value);
                    setDateOfBirth(obj.value);
                  } else {
                    const defaultDate = new Date(obj.value);
                    formMethods.setValue("dateOfBirth", defaultDate);
                    setDateOfBirth(formatDate(defaultDate as Date));
                  }
                  setDateOfBirthPlaceHolder(obj.value);
                } else {
                  // const maskedStatus: any = sessionStorage.getItem("maskEnabled");

                  if (dashboardApiData.masked_status) {
                    setDateOfBirthPlaceHolder("0***"); //this would disable dob while value is null in upadte

                  }
                }
              }
              if (obj.name === "cpp_qpp_exempt") {
                formMethods.setValue("cppQppExempt", obj.value);
              }
              if (obj.name === "ppip_exempt") {
                formMethods.setValue("ppipExempt", obj.value);
              }
              if (obj.name === "ei_exempt") {
                formMethods.setValue("eiExempt", obj.value);
              }
              if (obj.name === "employment_code") {
                formMethods.setValue("employmentCode", obj.value);
              }

            });
          }
          if (fieldName === "uniqueIdentifier") {
            const formattedNumber = fieldValue.replace(
              /(\d{3})(\d{3})(\d{3})/,
              "$1-$2-$3"
            );
            formMethods.setValue("uniqueIdentifier", formattedNumber);
          }
        });
        createNewActionFromSlipDDL();
        setIsPendingSlipData(false);
      }
    },
    [onResourceSelectionAPIsCalls]
  );

  // slipDataById in function
  const slipDataByIdPass = useCallback(
    (slipDataById: any, onResourceSelectionAPIsCalls: boolean) => {
      setIsPendingSlipData(true);
      if (slipDataById) {
        Object.keys(slipDataById).forEach((fieldName) => {

          // @ts-ignore
          const fieldValue = slipDataById[fieldName];

          // @ts-ignore

          if (typeof fieldValue !== "object") {
            // @ts-ignore
            formMethods.setValue(fieldName, fieldValue ?? undefined);
          } else if (fieldValue !== null || undefined) {

            Object.keys(fieldValue).forEach((objFieldName: any) => {

              // @ts-ignore
              const objFieldValue = fieldValue[objFieldName];


              if (typeof objFieldValue !== "object") {
                // @ts-ignore
                formMethods.setValue(objFieldName, objFieldValue ?? undefined);
              }

              if (objFieldName === "dateOfBirth") {
                if (objFieldValue !== null || undefined) {
                  if (objFieldValue.charAt(2) === "*") {
                    // alert("yes")
                    formMethods.setValue("dateOfBirth", objFieldValue);
                    setDateOfBirth(objFieldValue);
                  } else {
                    // alert("No")
                    const defaultDate = new Date(objFieldValue);

                    formMethods.setValue("dateOfBirth", defaultDate);
                    setDateOfBirth(formatDate(defaultDate as Date));

                  }
                  setDateOfBirthPlaceHolder(objFieldValue);
                } else if (objFieldValue === null) {
                  // const maskedStatus: any = sessionStorage.getItem("maskEnabled");
                  if (dashboardApiData.masked_status) {
                    setDateOfBirthPlaceHolder("0***"); //this would disable dob while value is null in upadte
                  }
                }
              }

              if (fieldName === "resource") {
                if (objFieldName === "externalId") {
                  setSelectedResource(objFieldValue);
                  setEditedResourceId(objFieldValue);
                  //for auto selected card
                  setSelectedCard(
                    String(objFieldValue)
                  );
                  formMethods.setValue(
                    "selectedEmployee",
                    objFieldValue
                  );
                  if (!onResourceSelectionAPIsCalls) {
                    (async () => {
                      try {
                        const response: any =
                          await T4SlipService.getResourceSlipDropDownList(
                            objFieldValue,
                            clientId,
                            taxYear
                          );
                        if (response && Array.isArray(response)) {
                          let resourceSlipList: IDropDownListResponse[] =
                            response.map(
                              (resourceSlip: IDropDownListResponse) => ({
                                label: resourceSlip.label,
                                value: resourceSlip.value,
                              })
                            );

                          resourceSlipList.unshift({
                            label: "Create New",
                            value: "create-new",
                          });


                          setSelectedResourceSlipList(resourceSlipList);
                          //for Cards scenario
                          if (
                            resourceSlipList &&
                            resourceSlipList.length > 1
                          ) {
                            // setSelectedResourceSlip(
                            //   String(resourceSlipList[1].value)
                            // );
                            setSelectedResourceSlip(
                              String(id)
                            );
                          } else {
                            setSelectedResourceSlip("create-new");
                          }
                        }
                      } catch (error) {
                        console.error("Error fetching data:", error);
                      }
                    })();
                  }

                }
                if (objFieldName === "reducedEi") {
                  if (objFieldValue === false) {
                    formMethods.setValue("reducedEi", 0);
                  } else if (objFieldValue === true) {
                    formMethods.setValue("reducedEi", 1);
                  }
                }
                if (objFieldName === "email") {
                  if (objFieldValue !== null) {
                    formMethods.setValue(objFieldName, objFieldValue);
                  } else {
                    // const maskedStatus: any =
                    //   sessionStorage.getItem("maskEnabled");

                    if (dashboardApiData.masked_status) {

                      formMethods.setValue("email", "ze*****3@gmail.com");
                    } else {
                      formMethods.setValue(objFieldName, "");
                    }
                  }
                }
              }
              if (objFieldName === "province") {
                let id = objFieldValue.id;
                let name = objFieldValue.name;
                let shortCode = objFieldValue.shortCode;

                // let selectedPOEwhenUpdate = objFieldValue.name;

                formMethods.setValue(
                  objFieldName,
                  // '{id:9, name: "Ontario",shortCode:"ON"}'
                  `{id:${id}, name: "${name}",shortCode:"${shortCode}"}`
                );
              }
              if (objFieldName === "provinceOfEmployment") {
                let id = objFieldValue.id;
                let name = objFieldValue.name;
                let shortCode = objFieldValue.shortCode;


                formMethods.setValue(
                  objFieldName,
                  // '{id:9, name: "Ontario",shortCode:"ON"}'
                  `{id:${id}, name: "${name}",shortCode:"${shortCode}"}`
                );
                if (objFieldValue.name === "Quebec") {
                  setShowbox17IfQC(true);
                  setSelectedProvinceOfEmployment("Quebec");
                } else {
                  setShowbox17IfQC(false);
                  setSelectedProvinceOfEmployment(name);

                }
              }
              if (objFieldName === "country") {
                formMethods.setValue(
                  objFieldName,
                  objFieldValue.name ?? undefined
                );
              }
              if (objFieldName === "uniqueIdentifier") {
                const formattedNumber = objFieldValue.replace(
                  /(\d{3})(\d{3})(\d{3})/,
                  "$1-$2-$3"
                );
                formMethods.setValue("uniqueIdentifier", formattedNumber);
              }
              if (objFieldName !== "email" && objFieldValue === null) {
                formMethods.setValue(objFieldName, "");
              }
            });
          }

          //set slip type according to edited row data for submit button action
          if (fieldName === "slipType") {
            selectedSlipTypee = fieldValue;
          }
          if (fieldName === "otherInformation") {
            if (fieldValue && fieldValue !== null && fieldValue.length !== 0) {
              setOiInEdit(true);
              formMethods.setValue("comparison", fieldValue);
            } else {
              setSlipOtherInformation([])
              setOiInEdit(true);
              formMethods.setValue("comparison", [
                { amount: 0, code: "", label: "" },
              ]);
            }
          }
          if (fieldName === "id") {
            // setNewCreatedSlipId(fieldValue)
            setSelectedResourceSlip(fieldValue);
            formMethods.setValue("selectedSlip", fieldValue);
            let path = `/taxslip/t4/setup/${fieldValue}`;
            navigate(path);
          }
          if (fieldName === "slipData") {
            Object.keys(fieldValue).forEach((slipDataFieldName: any) => {
              const slipDataFieldValue = fieldValue[slipDataFieldName];
              formMethods.setValue(
                slipDataFieldName,
                slipDataFieldValue && slipDataFieldValue !== null
                  ? parseFloat(slipDataFieldValue).toFixed(2)
                  : "0.00"
              );
              if (slipDataFieldName === "registrationNumber") {
                formMethods.setValue(slipDataFieldName, slipDataFieldValue);
              }
              if (slipDataFieldName === "employerOfferedDentalBenefits") {
                formMethods.setValue(slipDataFieldName, slipDataFieldValue);
              }
              // skdhvksdfbvksdfbvkisdf
              if (slipDataFieldName === "eiInsurableEarnings") {
                const provinceOfEmployment = slipDataById.resource.provinceOfEmployment && slipDataById.resource.provinceOfEmployment.name
                // alert(selectedPOEwhenUpdate)
                // alert(provinceOfEmployment)

                if (provinceOfEmployment && provinceOfEmployment !== "Quebec") {

                  let val1 = slipDataFieldValue;
                  let val2 =
                    dashboardApiData && dashboardApiData.global_variable && dashboardApiData.global_variable &&
                    dashboardApiData.global_variable?.data?.t4
                      ?.eiSettingsTotalEiEarningsMaximum;
                  if (val1 > val2 && val2) {

                    checkboxDefaultSelect = true;
                    formMethods.setValue("checkbox-eiInsurableEarnings", true);


                  } else {
                    checkboxDefaultSelect = false;
                    formMethods.setValue("checkbox-eiInsurableEarnings", false);

                  }
                }
                if (provinceOfEmployment && provinceOfEmployment === "Quebec") {

                  let val1 = slipDataFieldValue;
                  let val2 =
                    dashboardApiData && dashboardApiData.global_variable && dashboardApiData.global_variable &&
                    dashboardApiData.global_variable?.data?.rl1
                      ?.eiSettingsQubecTotalEiEarningsMaximum;
                  if (val1 > val2 && val2) {

                    checkboxDefaultSelect = true;
                    formMethods.setValue("checkbox-eiInsurableEarnings", true);

                  } else {
                    checkboxDefaultSelect = false;
                    formMethods.setValue("checkbox-eiInsurableEarnings", false);

                  }
                }
                // alert(slipDataFieldValue)
                formMethods.setValue(slipDataFieldName, parseFloat(slipDataFieldValue).toFixed(2));
              }
            });
          }
          if (fieldName === "adjustedSlipData") {
            Object.keys(fieldValue).forEach((adjSlipDataFieldName: any) => {
              const adjSlipDataFieldValue = fieldValue[adjSlipDataFieldName];

              formMethods.setValue(
                adjSlipDataFieldName,
                adjSlipDataFieldValue !== null || undefined
                  ? parseFloat(adjSlipDataFieldValue).toFixed(2)
                  : "0.00"
              );
            });
          }
        });

        let eiInsurableEarnings = slipDataById.slipData.eiInsurableEarnings
        let employmentIncome = slipDataById.slipData.employmentIncome
        let cppQppPensionableEarnings = slipDataById.slipData.cppQppPensionableEarnings

        if (Number(employmentIncome) !== Number(eiInsurableEarnings)) {
          formMethods.setValue("checkbox-eiInsurableEarnings", true);
        } else {
          formMethods.setValue("checkbox-eiInsurableEarnings", false);
        }
        if (Number(employmentIncome) !== Number(cppQppPensionableEarnings)) {
          formMethods.setValue("checkbox-cppQppPensionableEarnings", true);
        } else {
          formMethods.setValue("checkbox-cppQppPensionableEarnings", false);
        }
        setIsPendingSlipData(false);
      }
    },
    []
  );

  const { isPending: isPendingEmployeeDDLItems, data: employeeDDLItems } =
    useGetEmployeeDDLItems(clientId, EMPLOYEE_RESOURCE_LITERAL, taxYear);

  // for edit

  //for that slips which are completed
  const { isPending: isLoadingData, data: selectedT4SlipsData } = useGetData(
    completedSlipId,
    clientId,
    taxYear
  );
  // const { isPending: isLoadingDefaultSettingsData, data: defaultSettingsData } = useGetDefaultSettingsData(clientId);


  // const { isPending: isLoadingGlobalVariables, data: editDataRecord } =
  //   useGetGlobalVariables(taxYear);
  // const globalVariablesData: any = editDataRecord;

  // const { isPending: loadingSlipIds, data: t4SlipIds, refetch: refectchT4SlipIds } = useGetSlipIds("T4", clientId, taxYear);


  // const { isPending: isLoadingClientDataById, data: companyGetByIdRecord } =
  //   useGetCompanyData(clientId);

  useEffect(() => {
    if (employeeDDLItems) {
      if (employeeDDLItems && Array.isArray(employeeDDLItems)) {
        let resources: IDropDownListResponse[] = employeeDDLItems.map(
          (resourceItem: IDropDownListResponse) => ({
            // id: resourceItem.id,
            label: resourceItem.label,
            value: resourceItem.value,
          })
        );

        resources.unshift({
          label: "Create New",
          value: "create-new",
        });

        setSelectedResourceList(resources);
      }
      setResourceListWithoutCreateNew(sortData(employeeDDLItems));
    }
    if (dashboardApiData && dashboardApiData.client_detail && dashboardApiData.client_detail && dashboardApiData.client_detail.metaFields) {
      const paymentFor = dashboardApiData.client_detail.metaFields.find((item: any) => item.name === 'invoice_payment_for')

      setInvoicePaymentFor(paymentFor ? parseInt(paymentFor.value) : 10)
    }
  }, [dashboardApiData, employeeDDLItems])


  // const {
  //   isLoading: isLoadingSummaryGetData,
  //   data: t4SummaryData } =
  //   useGetT4SummaryData(clientId, selectedT4SummaryType, taxYear);
  // const {
  //   isLoading: isLoadingSummaryReduceEIGetData,
  //   data: t4SummaryReduceEIData } =
  //   useGetT4SummaryReduceEIData(clientId, selectedT4SummaryReduceEIType, taxYear);

  // useEffect(() => {
  //   //get by id slip
  //   setIsLoadingAdjustedData(true);
  //   setTimeout(() => {
  //     setIsLoadingAdjustedData(false);
  //   }, 2000);
  //   const fetchData = async () => {
  //     try {
  //       const response: any = await T4SlipService.getT4SlipById(
  //         completedSlipId,
  //         clientId,
  //         taxYear
  //       );
  //                     
  //       setT4SlipRecord(response);
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //   };

  //   fetchData();
  // }, []);

  useEffect(() => {
    if (selectedT4SlipsData) {
      setT4SlipRecord(selectedT4SlipsData);
    }
  }, [selectedT4SlipsData]);


  //for that slips which are not started yet
  const {
    isLoading: isLoadingNotStartedSlipId,
    data: selectedNotStartedResourceData,
    // refetch: refetchResourceSlips,
  } = useGetResourceInformationById(notStartedSlipId, clientId, "Employee");


  // const { isPending: isLoadingDropDownList, data: resourceList } =
  //   useGetResourceDDLData(clientId, EMPLOYEE_RESOURCE_LITERAL);

  // const {
  //   isLoading: isLoadingResourceSlips,
  //   data: resourceSlips,
  //   refetch: refetchResourceSlips,
  // } = useGetResourceSlips(selectedResource, clientId, taxYear);


  // const {
  //   isLoading: isLoadingResourceInfo,
  //   data: resourceInfo,
  //   // refetch: refetchResourceSlips,
  // } = useGetResourceInformationById(selectedResourceId, clientId, "Employee");


  // const {
  //   isLoading: isLoadingSlipData,
  //   data: slipRecord,
  //   isFetching: reFetchingSlipData,
  //   refetch: refetchSlipRecord,
  // } = useGetSlipRecord(selectedResourceSlip, clientId, taxYear);


  // const resourceListItems = useMemo(() => {
  //   if (resourceList && Array.isArray(resourceList)) {
  //     let resources: IDropDownListResponse[] = resourceList.map(
  //       (resourceItem: IDropDownListResponse) => ({
  //         id: resourceItem.id,
  //         label: resourceItem.label,
  //         value: resourceItem.value,
  //       })
  //     );

  //     resources.unshift({
  //       label: "Create New",
  //       value: "create-new",
  //     });
  //     setSelectedResourceList(resourceList)
  //     return resources;
  //   }

  //   return [
  //     {
  //       label: "Create New",
  //       value: "create-new",
  //     },
  //   ];
  // }, [resourceList]);


  // const resourceSlipListItems = useMemo(() => {
  //   if (resourceSlips && Array.isArray(resourceSlips)) {
  //     let resourceSlipList: IDropDownListResponse[] = resourceSlips.map(
  //       (resourceSlip: IDropDownListResponse) => ({
  //         label: resourceSlip.label,
  //         value: resourceSlip.value,
  //       })
  //     );

  //     resourceSlipList.unshift({
  //       label: "Create New",
  //       value: "create-new",
  //     });
  //     setSelectedResourceSlipList(resourceSlipList);
  //     return resourceSlipList;
  //   }

  //   return [
  //     {
  //       label: "Create New",
  //       value: "create-new",
  //     },
  //   ];
  // }, [resourceSlips]);


  /**
   * Handle when the form is submitted.
   *
   * @param {IT4SlipRequestPayload} formData
   */

  const [T4OtherInformationList, setT4OtherInformationList] =
    useState<any>(undefined);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response: any = await T4OtherInformationService.getT4OI();
        setT4OtherInformationList(response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const [isDOBAtLeast10YearsAgo, setIsDOBAtLeast10YearsAgo] = useState(false);

  const onSubmit = (formData: any) => {

    // if (dateOfBirth.charAt(2) !== "*" && dateOfBirth !== null && dateOfBirth !== "") {
    //   const userDateOfBirth = new Date(dateOfBirth);
    //   const currentDate = new Date();

    //   const isAtLeast10YearsAgo = currentDate.getFullYear() - userDateOfBirth.getFullYear() >= 10;

    //   setIsDOBAtLeast10YearsAgo(isAtLeast10YearsAgo)
    // }

    // if(isDOBAtLeast10YearsAgo === false){
    //   setSnackbarData({
    //         open: true,
    //         message: "Date of birth must be at least 10 years back!",
    //         severity: "error",
    //       });

    // }
    // else {

    //province is in string format and by using this we convert that in object
    const jsonString = formData.province as string;
    // Custom parsing function to convert the JSON-like string to an object
    const parseJSONLikeString = (str: string) => {
      // Use regular expressions to add double quotes around keys and string values
      const modifiedString = str.replace(/(\w+):/g, '"$1":').replace(/'/g, '"');
      // Convert the modified JSON string to an object using JSON.parse()
      return JSON.parse(modifiedString);
    };
    // Convert the JSON-like string to an object
    const provinceObject = parseJSONLikeString(jsonString);


    //province is in string format and by using this we convert that in object
    const jsonStringPoe = formData.provinceOfEmployment as string;
    // Custom parsing function to convert the JSON-like string to an object
    const parseJSONLikeStringPeo = (str: string) => {
      // Use regular expressions to add double quotes around keys and string values
      const modifiedString = str.replace(/(\w+):/g, '"$1":').replace(/'/g, '"');
      // Convert the modified JSON string to an object using JSON.parse()
      return JSON.parse(modifiedString);
    };
    // Convert the JSON-like string to an object
    const poeObject = parseJSONLikeStringPeo(jsonStringPoe);


    //other Information
    const getValue = formMethods.getValues("comparison");
    console.log('FilteredSelectedOtherInfoT4A', FilteredSelectedOtherInfoT4)
    console.log('getValue', getValue)
    console.log('T4AOtherInformationList', T4OtherInformationList)
    const finalOtherInformatioItems = FilteredSelectedOtherInfoT4.map(
      (item: any) => {
        const valueItem = getValue.find(
          (value: any) => value.code === item.code
        );
        const getLabelIfMissingInItem =
          T4OtherInformationList &&
          T4OtherInformationList.find(
            (value: any) => value.value === item.code
          );
        console.log('getLabelIfMissingInItem', getLabelIfMissingInItem)

        return {
          ...item,
          amount: valueItem.amount,
          label: getLabelIfMissingInItem.label,
        };
      }
    );

    console.log('formData.eiInsurableEarnings', formData.eiInsurableEarnings)

    const requestPayload: IT4SlipRequestPayload = {
      // clientId: formData.clientId,
      // taxYear:formData.taxYear,
      // id: formData.id,
      clientId: clientId,
      taxYear: taxYear,
      id:
        selectedT4SlipsData && selectedT4SlipsData.resource
          ? // && editedRecordSlipCreateNew === false
          selectedT4SlipsData.id
          : T4SlipRecord && T4SlipRecord.id ? T4SlipRecord.id
            :
            // : newCreatedSlipId !== '' && editedRecordSlipCreateNew === false ? newCreatedSlipId
            undefined,
      // applyAdjustments: formData.applyAdjustments,
      ignoredEiAuditEarning: false, //this tag is for audit earnings ignore tag
      ignoredCppAuditEarning: false, //this tag is for audit earnings ignore tag
      ignoredDuplicateSlips: false, //ignore duplicate employees
      applyAdjustments: formData.applyAdjustments !== "false" ? true : false,
      saveAdjutments: formData.applyAdjustments !== "true" ? false : true, //if apply adj true then true ow false
      reflectMasterData: formData.reflectMasterData,
      slipType: formData.slipType,
      slipStatus: formData.slipStatus,
      pensionablePeriod: formData.pensionablePeriod,
      otherInformation:
        formData.comparison[0].code !== "" ? finalOtherInformatioItems : [],
      resource: {
        externalId:
          selectedResource !== "create-new"
            ? selectedResource
            : selectedT4SlipsData && selectedT4SlipsData.resource
              ? selectedT4SlipsData.resource.externalId
              : // : newCreatedResourceId !== '' ? newCreatedResourceId
              selectedNotStartedResourceData && selectedNotStartedResourceData.id
                ? selectedNotStartedResourceData.id
                : undefined,
        // externalId:selectedResourceSlip !== "create-new" ? selectedResourceSlip : (selectedT4SlipsData && selectedT4SlipsData.resource) ? selectedT4SlipsData.resource.externalId : undefined,
        // externalId:
        //   selectedResource !== "create-new"
        //     ? selectedResource
        //     : selectedT4SlipsData !== undefined || null
        //     ? selectedT4SlipsData.resource.externalId
        //     : undefined,
        // externalId:selectedResourceId,
        // externalId:"6daf1279-a74f-458a-a973-5f8eda0c72f4", //resource id of => //testRL ed3 test
        firstName: formData.name1,
        initials: formData.initials,
        lastName: formData.name2,
        // dateOfBirth: formData.dateOfBirth,
        dateOfBirth:
          dateOfBirth.charAt(2) === "*"
            ? undefined
            : dateOfBirth !== "" || null
              ? dateOfBirth
              : undefined,
        socialInsuranceNumber: formData.uniqueIdentifier.replace(/-/g, ""),
        address: formData.addressLine1,
        city: formData.city,
        // province:provinceResponce,
        // province: formData.province,
        province: provinceObject, //when edit then it show n select so this technique is use bcz we cant assign fieldvalue according to field name by using direct object so first we change that oobject to string then we chnage that string to obj and send to payload
        country: CountryResponse,
        postCode:
          formData.postalCode &&
          formData.postalCode.replace(/[a-z]/g, (match: string) =>
            match.toUpperCase()
          ),
        // provinceOfEmployment:provinceOfEmploymentRes,
        // provinceOfEmployment: formData.provinceOfEmployment,
        provinceOfEmployment: poeObject,
        email:
          formData.email !== "" && formData.email !== "ze*****3@gmail.com"
            ? formData.email
            : undefined,
        employeeCode: parseInt(formData.employeeCode),
        // employeeCode: formData.employeeCode,
        cppQppExempt: formData.cppQppExempt,
        eiExempt: formData.eiExempt,
        ppipExempt: formData.ppipExempt,
        employmentCode:
          formData.employmentCode !== undefined &&
            formData.employmentCode !== ""
            ? formData.employmentCode
            : null,
        payPeriod: formData.payPeriod,
        reducedEi: formData.reducedEi,
      },
      overRemittance: 0,
      slipData: {
        employmentIncome: formData.employmentIncome && formData.employmentIncome !== null ? parseFloat(formData.employmentIncome.replace(/[$,]/g, '')) : 0,
        cppContributions:
          selectedProvinceOfEmployment !== "Quebec" && formData.cppContributions && formData.cppContributions !== null
            ? parseFloat(formData.cppContributions.replace(/[$,]/g, ''))
            : 0,
        secondCppContributions:
          selectedProvinceOfEmployment !== "Quebec" && taxYear > 2023 && formData.secondCppContributions && formData.secondCppContributions !== null
            ? parseFloat(formData.secondCppContributions.replace(/[$,]/g, ''))
            : 0,
        qppContributions:
          selectedProvinceOfEmployment === "Quebec" && formData.qppContributions !== null && formData.qppContributions !== undefined
            ? parseFloat(formData.qppContributions.replace(/[$,]/g, ''))
            : 0,
        secondQppContributions:
          selectedProvinceOfEmployment === "Quebec" && taxYear > 2023 && formData.secondQppContributions !== null && formData.secondQppContributions !== undefined
            ? parseFloat(formData.secondQppContributions.replace(/[$,]/g, ''))
            : 0,
        eiPremiums: formData.eiPremiums && formData.eiPremiums !== null ? parseFloat(formData.eiPremiums.replace(/[$,]/g, '')) : 0,
        rppContributions: formData.rppContributions && formData.rppContributions !== null ? parseFloat(formData.rppContributions.replace(/[$,]/g, '')) : 0,
        incomeTaxDeducted: formData.incomeTaxDeducted && formData.incomeTaxDeducted !== null ? parseFloat(formData.incomeTaxDeducted.replace(/[$,]/g, '')) : 0,
        eiInsurableEarnings: formData.eiInsurableEarnings && formData.eiInsurableEarnings !== null ? parseFloat(formData.eiInsurableEarnings.replace(/[$,]/g, '')) : 0,
        cppQppPensionableEarnings: formData.cppQppPensionableEarnings && formData.cppQppPensionableEarnings !== null ? parseFloat(
          formData.cppQppPensionableEarnings.replace(/[$,]/g, '')
        ) : 0,
        unionDues: formData.unionDues && formData.unionDues !== null ? parseFloat(formData.unionDues.replace(/[$,]/g, '')) : 0,
        charitableDonations: formData.charitableDonations && formData.charitableDonations !== null ? parseFloat(formData.charitableDonations.replace(/[$,]/g, '')) : 0,
        registrationNumber: formData.registrationNumber && formData.registrationNumber !== null ? parseInt(formData.registrationNumber) : undefined,
        pensionAdjustment: formData.pensionAdjustment && formData.pensionAdjustment !== null ? parseFloat(formData.pensionAdjustment.replace(/[$,]/g, '')) : 0,
        ppipPremiums: formData.ppipPremiums && formData.ppipPremiums !== null ? parseFloat(formData.ppipPremiums.replace(/[$,]/g, '')) : 0,
        ppipInsurableEarnings: formData.ppipInsurableEarnings && formData.ppipInsurableEarnings !== null ? parseFloat(formData.ppipInsurableEarnings.replace(/[$,]/g, '')) : 0,
        employerOfferedDentalBenefits:
          formData.employerOfferedDentalBenefits && formData.employerOfferedDentalBenefits !== ""
            ? formData.employerOfferedDentalBenefits
            : null,
      },
      adjustedSlipData: {
        employmentIncome: formData.employmentIncomeAdjusted && parseFloat(formData.employmentIncomeAdjusted.replace(/[$,]/g, '')),
        cppContributions:
          selectedProvinceOfEmployment !== "Quebec" && formData.cppContributionsAdjusted
            ? parseFloat(formData.cppContributionsAdjusted.replace(/[$,]/g, ''))
            : 0,
        secondCppContributions:
          selectedProvinceOfEmployment !== "Quebec" && taxYear > 2023 && formData.secondCppContributionsAdjusted
            ? parseFloat(formData.secondCppContributionsAdjusted.replace(/[$,]/g, ''))
            : 0,
        qppContributions:
          selectedProvinceOfEmployment === "Quebec" && formData.qppContributionsAdjusted && formData.qppContributionsAdjusted !== null
            ? parseFloat(formData.qppContributionsAdjusted.replace(/[$,]/g, ''))
            : 0,
        secondQppContributions:
          selectedProvinceOfEmployment === "Quebec" && taxYear > 2023 && formData.secondQppContributionsAdjusted && formData.secondQppContributionsAdjusted !== null
            ? parseFloat(formData.secondQppContributionsAdjusted.replace(/[$,]/g, ''))
            : 0,
        eiPremiums: formData.eiPremiumsAdjusted && parseFloat(formData.eiPremiumsAdjusted.replace(/[$,]/g, '')),
        incomeTaxDeducted: formData.incomeTaxDeductedAdjusted && parseFloat(formData.incomeTaxDeductedAdjusted.replace(/[$,]/g, '')),
        eiInsurableEarnings: formData.eiInsurableEarningsAdjusted && parseFloat(formData.eiInsurableEarningsAdjusted.replace(/[$,]/g, '')),
        ppipPremiums: formData.ppipPremiumsAdjusted && parseFloat(formData.ppipPremiumsAdjusted.replace(/[$,]/g, '')),
        ppipInsurableEarnings: formData.ppipInsurableEarningsAdjusted && parseFloat(
          formData.ppipInsurableEarningsAdjusted.replace(/[$,]/g, '')
        ),
      },
      t4SummaryConfirmationCode: dashboardApiData && dashboardApiData.t4_summary && dashboardApiData.t4_summary.confirmationCode,
      t4SummaryReduceEIConfirmationCode: dashboardApiData && dashboardApiData.t4_summary_reduce_ei && dashboardApiData.t4_summary_reduce_ei.confirmationCode,
      selectedSlipTypeById: T4SlipRecord && T4SlipRecord.slipType
    };


    // if (formData.comparison[0].amount !== "") {
    // 
    // } else {
    //  ;
    // }
    // submitFlexFields(formData);
    // alert(formData.employmentCode)

    // console.log('requestPayload',requestPayload)
    submitFlexFields(requestPayload);
    // }
  };

  const defaultSettingsCalls = () => {
    if (!id && !T4SlipRecord && dashboardApiData && dashboardApiData.default_setting && dashboardApiData.default_setting.t4DefaultSetting) {
      // setSlipOtherInformation([])
      if (dashboardApiData.default_setting.t4DefaultSetting.otherInformation) {
        if (dashboardApiData.default_setting.t4DefaultSetting.otherInformation && dashboardApiData.default_setting.t4DefaultSetting.otherInformation !== null && dashboardApiData.default_setting.t4DefaultSetting.otherInformation.length !== 0) {
          setOiInEdit(true);
          formMethods.setValue("comparison", dashboardApiData.default_setting.t4DefaultSetting.otherInformation);
        }
        else {
          //   // setOiInEdit(true);
          formMethods.setValue("comparison", [
            { amount: 0, code: "", label: "" },
          ]);
        }
      }
      if (dashboardApiData.default_setting.t4DefaultSetting.rppDpspRegistration && dashboardApiData.default_setting.t4DefaultSetting.rppDpspRegistration !== '' && dashboardApiData.default_setting.t4DefaultSetting.rppDpspRegistration > 0) {
        formMethods.setValue('registrationNumber', dashboardApiData.default_setting.t4DefaultSetting.rppDpspRegistration)
      }
      if (dashboardApiData.default_setting.fillingDataAttribute) {
        if (dashboardApiData.default_setting.fillingDataAttribute.provinceOfEmployment) {
          let id = dashboardApiData.default_setting.fillingDataAttribute.provinceOfEmployment.id;
          let name = dashboardApiData.default_setting.fillingDataAttribute.provinceOfEmployment.name;
          let shortCode = dashboardApiData.default_setting.fillingDataAttribute.provinceOfEmployment.shortCode;
          formMethods.setValue(
            'provinceOfEmployment',
            `{id:${id}, name: "${name}",shortCode:"${shortCode}"}`
          );
          if (dashboardApiData.default_setting.fillingDataAttribute.provinceOfEmployment.name === "Quebec") {
            setShowbox17IfQC(true);
            setSelectedProvinceOfEmployment("Quebec");
          } else {
            setShowbox17IfQC(false);
            setSelectedProvinceOfEmployment(name);
          }
        }
        if (dashboardApiData.default_setting.fillingDataAttribute.province) {
          let id = dashboardApiData.default_setting.fillingDataAttribute.province.id;
          let name = dashboardApiData.default_setting.fillingDataAttribute.province.name;
          let shortCode = dashboardApiData.default_setting.fillingDataAttribute.province.shortCode;
          formMethods.setValue(
            'province',
            `{id:${id}, name: "${name}",shortCode:"${shortCode}"}`
          );
        }
        if (dashboardApiData.default_setting.fillingDataAttribute.city) {
          formMethods.setValue('city', dashboardApiData.default_setting.fillingDataAttribute.city)
        }
        if (dashboardApiData.default_setting.fillingDataAttribute.cppQppExempt) {
          formMethods.setValue('cppQppExempt', dashboardApiData.default_setting.fillingDataAttribute.cppQppExempt)
        }
        if (dashboardApiData.default_setting.fillingDataAttribute.eiExempt) {
          formMethods.setValue('eiExempt', dashboardApiData.default_setting.fillingDataAttribute.eiExempt)
        }
        if (dashboardApiData.default_setting.fillingDataAttribute.ppipExempt) {
          formMethods.setValue('ppipExempt', dashboardApiData.default_setting.fillingDataAttribute.ppipExempt)
        }
        if (dashboardApiData.default_setting.fillingDataAttribute.employmentCode) {
          formMethods.setValue('employmentCode', dashboardApiData.default_setting.fillingDataAttribute.employmentCode)
        }
        if (dashboardApiData.default_setting.fillingDataAttribute.payPeriod) {
          formMethods.setValue('payPeriod', dashboardApiData.default_setting.fillingDataAttribute.payPeriod)
        }
        if (dashboardApiData.default_setting.fillingDataAttribute.reducedEi) {
          formMethods.setValue('reducedEi', dashboardApiData.default_setting.fillingDataAttribute.reducedEi)
        }
      }
    } else if (!id && !T4SlipRecord && dashboardApiData && !dashboardApiData.default_setting) {
      formMethods.setValue("comparison", [{ amount: 0, code: "", label: "" }]);
      setSlipOtherInformation([{ amount: 0, code: 'null', label: 'Empty Field' }])
    }
  }

  const onResetClicked = () => {
    setSnackbarData({
      open: true,
      message: "Form was reset successfully",
      severity: "success",
    });
    formMethods.reset();
    createNewActionFromSlipDDL();
    formMethods.setValue("comparison", [{ amount: 0, code: "", label: "" }]);
    setSlipOtherInformation([])
    setDateOfBirth("");
    setDateOfBirthPlaceHolder("");
    setSelectedResourceSlipList([{ label: "Create New", value: "create-new" }]);
    setSelectedResourceSlip("create-new");
    setSelectedOtherInformation(false);
    setSelectedResource("create-new");
    setSelectedCard(null);
    let path = `/taxslip/t4/setup`;
    navigate(path);
    setT4SlipRecord(undefined);
    defaultSettingsCalls();
    window.location.reload();
  };

  // For Delete Row

  const { isPending: isDeleting, mutate: deleteT4SlipById } = useMutation({
    mutationFn: T4SlipService.delT4Slip,

    onSuccess: (res: any | IServerError | IResponse) => {

      if (typeof res === "string") {
        // remove the cache of the Year fields since we just added a new field.
        setSnackbarData({
          open: true,
          message: "Record has been deleted successfully.",
          severity: "success",
        });
        setT4SlipRecord(undefined);
        defaultSettingsCalls()
        // refectchT4SlipIds()
      } else {
        setSnackbarData({
          open: true,
          // message: "Something went wrong, try again later!",
          message: res.message,
          severity: "error",
        });
      }

      //load Employee Data
      if (res) {
        const selectedEmployee = formMethods.getValues("selectedEmployee");

        if (selectedEmployee !== "create-new") {
          let path = `/taxslip/t4/setup/${selectedEmployee}`;
          navigate(path);
          const fetchData = async () => {
            try {
              const response: any =
                await T4SlipService.getResourceSlipDropDownList(
                  selectedEmployee,
                  clientId,
                  taxYear
                );

              if (response && Array.isArray(response)) {
                let resourceSlipList: IDropDownListResponse[] =
                  response.map((resourceSlip: IDropDownListResponse) => ({
                    label: resourceSlip.label,
                    value: resourceSlip.value,
                  }));

                resourceSlipList.unshift({
                  label: "Create New",
                  value: "create-new",
                });


                setSelectedResourceSlipList(resourceSlipList);
                formMethods.setValue(
                  "selectedSlip",
                  resourceSlipList[0].value
                );
                createNewActionFromSlipDDL();
              }
            } catch (error) {
              console.error("Error fetching data:", error);
            }
          };
          fetchData();
        }
      }
      selectedSlipTypee = formMethods.getValues("slipType");
      setSelectedOtherInformation(true);
    },
    onError: (err: any) => {
      setSnackbarData({
        open: true,
        // message: "Something went wrong, try again later!",
        message: err.message,
        severity: "error",
      });
    },
  }
  );

  const deleteT4SlipField = () => {
    if (singleDelete) {
      let payload = {
        t4SlipId,
        clientId,
        taxYear,
      };
      setSingleDelete(false);
      deleteT4SlipById(payload);
      setDialogOpen(false);
    }
  };

  const onDeleteClicked = () => {
    setDialogOpen(true);
    setSingleDelete(true);
    setApiAction("delete");
    if (
      T4SlipRecord &&
      T4SlipRecord.resource
    ) {
      setT4SlipId(T4SlipRecord.id);
    }
  };

  const savePdfAsFile = (pdfData: any, filename: any) => {
    const blob = new Blob([pdfData], { type: "application/pdf" });
    FileSaver.saveAs(blob, filename);

    fileeeee = pdfData;
  };
  const onPrintClicked = async (printType: any): Promise<void> => {
    // const maskedStatus: any = sessionStorage.getItem("maskEnabled");
    if (dashboardApiData.masked_status) {
      setIsLoadingData(false);
      setSnackbarData({
        open: true,
        message: "Please unmask your data.",
        severity: "error",
      });
    } else {
      setIsLoadingData(true);
      if (invoicePaymentFor === 10) {
        try {
          const previousYearInvoiceResponse: any = await ReportsService.getPreviousYearInvoice(
            clientId,
            taxYear - 1
          );
          try {
            const response: any = await ReportsService.createInvoice(
              clientId,
              taxYear
            );
            setIsLoadingData(false);

            if (previousYearInvoiceResponse.message === "Slips not found for invoice." && response.message === "Slips not found for invoice.") {
              // setIsLoadingData(true);
              // try {
              //   const filingAuditResponse: any =
              //     await T4SlipService.getT4AuditFiling(clientId, taxYear);
              // 
              //   if (
              //     filingAuditResponse &&
              //     filingAuditResponse.general_filling &&
              //     filingAuditResponse.general_filling.length > 0
              //   ) {
              //   
              //   
              //     setSnackbarData({
              //       open: true,
              //       message: (
              //         <>
              //           Please load Audit in the menu and clear all audit items
              //           (Audit Filing and PIER Review) to generate documents.{" "}
              //           <a
              //             href="https://appv3.taxslips.com/#/audit/filing"
              //             style={{
              //               color: "#aa1010",
              //               textDecoration: "none",
              //               fontWeight: "bold",
              //             }}
              //           >
              //             Click here to view
              //           </a>
              //         </>
              //       ),
              //       severity: "error",
              //       autoHide: false,
              //     });
              //   } else if (
              //     filingAuditResponse &&
              //     filingAuditResponse.t4_filling &&
              //     filingAuditResponse.t4_filling.length > 0
              //   ) {
              //     
              //     setSnackbarData({
              //       open: true,
              //       message: (
              //         <>
              //           Please load Audit in the menu and clear all audit items
              //           (Audit Filing and PIER Review) to generate documents.{" "}
              //           <a
              //             href="https://appv3.taxslips.com/#/audit/filing"
              //             style={{
              //               color: "#aa1010",
              //               textDecoration: "none",
              //               fontWeight: "bold",
              //             }}
              //           >
              //             Click here to view
              //           </a>
              //         </>
              //       ),
              //       severity: "error",
              //       autoHide: false,
              //     });
              //   } else {
              try {
                const t4SlipIdsAndAuditStatus: any =
                  await T4SlipService.getSlipIds("T4", clientId, taxYear);
                if (t4SlipIdsAndAuditStatus && t4SlipIdsAndAuditStatus.generalAuditStatus !== null && t4SlipIdsAndAuditStatus.generalAuditStatus === true &&
                  t4SlipIdsAndAuditStatus && t4SlipIdsAndAuditStatus.auditStatus !== null && t4SlipIdsAndAuditStatus.auditStatus === true) {
                  setIsLoadingData(true);
                  try {
                    const jsonString = formMethods.getValues("provinceOfEmployment")
                      ? formMethods.getValues("provinceOfEmployment")
                      : ('{id:9, name: "Ontario",shortCode:"ON"}' as string);
                    const ProvinceOfEmploymentData =
                      parseJSONLikeString(jsonString);
                    // const response: any = await PrintingService.createSingleT4PdfPrint(
                    //   clientId,
                    //   editedResourceId,
                    //   formMethods.getValues("slipType"),
                    //   printType,
                    //   ProvinceOfEmploymentData.shortCode,
                    //   taxYear
                    // );
                    let pdfIds = `t4_slip_ids=${id}`;
                    const response: any =
                      await PrintingService.createBulkT4PdfPrint(
                        clientId,
                        printType,
                        pdfIds,
                        taxYear
                      );
                    if (response.status === 400) {
                      setSnackbarData({
                        open: true,
                        message: response.data.message
                          ? response.data.message
                          : "Something went wrong.",
                        // message: "Please Unmask sensitive data for PDF printing.",
                        severity: "error",
                      });
                    } else {
                      const employeeFirstName = formMethods.getValues("name1");
                      const employeeLastName = formMethods.getValues("name2");
                      const filename = `T4slip-${employeeFirstName} ${employeeLastName}-${printType}.pdf`;
                      savePdfAsFile(response, filename);

                    }
                    setIsLoadingData(false);
                  } catch (err) {

                    alert(err);
                  }
                  // }
                  setIsLoadingData(false);
                } else {
                  setIsLoadingData(false);
                  setSnackbarData({
                    open: true,
                    message: (
                      <>
                        Please load Audit in the menu, press Run T4 Audit and clear all audit items (Audit Filing and PIER Review) to generate documents.{" "}
                        <a
                          href="https://appv3.taxslips.com/#/audit/filing"
                          style={{
                            color: "#aa1010",
                            textDecoration: "none",
                            fontWeight: "bold",
                          }}
                        >
                          Click here to view
                        </a>
                      </>
                    ),
                    severity: "error",
                    autoHide: false,
                  });
                }
              } catch (err: any) {
                setIsLoadingData(false);
              }
            } else if (
              response?.id != null &&
              previousYearInvoiceResponse?.id != null
            ) {

              setInvoiceData([previousYearInvoiceResponse, response]);
              setInvoiceDialogOpen(true);
            } else if (
              previousYearInvoiceResponse?.id != null &&
              response?.message === "Slips not found for invoice."
            ) {

              setInvoiceData([previousYearInvoiceResponse]);
              setInvoiceDialogOpen(true);
            } else if (
              response?.id != null &&
              previousYearInvoiceResponse?.message === "Slips not found for invoice."
            ) {

              setInvoiceData([response]);
              setInvoiceDialogOpen(true);
            } else {
              setSnackbarData({
                open: true,
                message: "Something went wrong.",
                severity: "error",
              });
            }
            setIsLoadingData(false);
          } catch (err) {

            setIsLoadingData(false);
          }
        } catch (err) {

          setIsLoadingData(false);
        }
      } else {
        try {
          const response: any = await ReportsService.createInvoice(
            clientId,
            taxYear
          );
          setIsLoadingData(false);

          if (response.message === "Slips not found for invoice.") {
            try {
              const t4SlipIdsAndAuditStatus: any =
                await T4SlipService.getSlipIds("T4", clientId, taxYear);
              if (t4SlipIdsAndAuditStatus && t4SlipIdsAndAuditStatus.generalAuditStatus !== null && t4SlipIdsAndAuditStatus.generalAuditStatus === true &&
                t4SlipIdsAndAuditStatus && t4SlipIdsAndAuditStatus.auditStatus !== null && t4SlipIdsAndAuditStatus.auditStatus === true) {
                setIsLoadingData(true);
                try {
                  const jsonString = formMethods.getValues("provinceOfEmployment")
                    ? formMethods.getValues("provinceOfEmployment")
                    : ('{id:9, name: "Ontario",shortCode:"ON"}' as string);
                  const ProvinceOfEmploymentData =
                    parseJSONLikeString(jsonString);
                  let pdfIds = `t4_slip_ids=${id}`;
                  const response: any =
                    await PrintingService.createBulkT4PdfPrint(
                      clientId,
                      printType,
                      pdfIds,
                      taxYear
                    );
                  if (response.status === 400) {
                    setSnackbarData({
                      open: true,
                      message: response.data.message
                        ? response.data.message
                        : "Something went wrong.",
                      severity: "error",
                    });
                  } else {
                    const employeeFirstName = formMethods.getValues("name1");
                    const employeeLastName = formMethods.getValues("name2");
                    const filename = `T4slip-${employeeFirstName} ${employeeLastName}-${printType}.pdf`;
                    savePdfAsFile(response, filename);

                  }
                  setIsLoadingData(false);
                } catch (err) {

                  alert(err);
                }
                setIsLoadingData(false);
              } else {
                setIsLoadingData(false);
                setSnackbarData({
                  open: true,
                  message: (
                    <>
                      Please load Audit in the menu, press Run T4 Audit and clear all audit items (Audit Filing and PIER Review) to generate documents.{" "}
                      <a
                        href="https://appv3.taxslips.com/#/audit/filing"
                        style={{
                          color: "#aa1010",
                          textDecoration: "none",
                          fontWeight: "bold",
                        }}
                      >
                        Click here to view
                      </a>
                    </>
                  ),
                  severity: "error",
                  autoHide: false,
                });
              }
            } catch (err: any) {
              setIsLoadingData(false);
            }
          } else if (response && response.id !== null) {
            setInvoiceData([response]);
            setInvoiceDialogOpen(true);
          } else {
            setSnackbarData({
              open: true,
              message: "Something went wrong.",
              severity: "error",
            });
          }
          setIsLoadingData(false);
        } catch (err) {

          setIsLoadingData(false);
        }
      }
    }
  };



  const onUnPaidClickHandler = (clickedRow: any, tag: string) => {
    setIsLoadingData(true);
    // setTimeout(() => {
    //   setIsLoadingData(false);
    // }, 2500);
    const fetchData = async () => {
      try {
        const response: any =
          await ReportsService.paypalIntegrationOfUnpaidInvoice(
            clientId,
            clickedRow.refNo,
            tag
          );
        setIsLoadingData(false);

        if (tag === 'paypal') {
          window.open(response, '_blank');
        } else {
          window.open(response.message, '_blank');
        }
      } catch (error) {
        setIsLoadingData(false);
        console.error("Error fetching data:", error);
      } finally {
        setIsLoadingData(false);
      }
    }
    fetchData();

  };

  const onClickInvoiceNoHandler = (clickedRow: any) => {
    dispatch(setSelectedINVOICE(clickedRow));

  };
  /**
   * On Snackbar closed.
   *
   * @param {React.SyntheticEvent | Event} event
   * @param {string} reason
   */
  const onSnackbarClosed = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarData(INITIAL_SNACKBAR_DATA);
  };

  // const otherInformationList = useMemo(() => {
  //   return [
  //     {
  //       label: "N/A",
  //       value: "0",
  //     },
  //     {
  //       label: "30 - Board and lodging",
  //       value: "30",
  //     },
  //     {
  //       label: "31 - Special work site",
  //       value: "31",
  //     },
  //     {
  //       label: "32 - Travel in a prescribed zone",
  //       value: "32",
  //     },
  //   ];
  // }, []);

  // set the values of the selected Slip from DDL coming from BE.
  // useEffect(() => {
  // if the selected flex field data has loaded.
  // if (slipRecord) {
  //   Object.keys(slipRecord).forEach((fieldName) => {
  //     // @ts-ignore
  //     const fieldValue = slipRecord[fieldName];
  //    
  //     if (typeof fieldValue !== "object") {
  //       // @ts-ignore
  //       formMethods.setValue(fieldName, fieldValue);
  //     }
  //     if (fieldName === "resource") {
  //       Object.keys(fieldValue).forEach((resourceFieldName) => {
  //         const resourceFieldValue = fieldValue[resourceFieldName];
  //         // @ts-ignore
  //         formMethods.setValue(resourceFieldName, resourceFieldValue);
  //       
  //         if(resourceFieldName === 'dateOfBirth'){
  //           if(resourceFieldValue !== null || undefined){
  //           if(resourceFieldValue.charAt(2) === "*"){
  //             // alert("yes")
  //             formMethods.setValue('dateOfBirth', resourceFieldValue);
  //             setDateOfBirth(resourceFieldValue)
  //           }else{
  //             // alert("No")
  //             const defaultDate = new Date(resourceFieldValue);
  //             formMethods.setValue('dateOfBirth', defaultDate);
  //             setDateOfBirth(formatDate(defaultDate as Date))
  //           }
  //           setDateOfBirthPlaceHolder(resourceFieldValue)
  //         }
  //       }
  //         if (resourceFieldName === "country") {
  //           formMethods.setValue(
  //             resourceFieldName,
  //             resourceFieldValue.name ?? undefined
  //           );
  //         }
  //         if (resourceFieldName === "province") {
  //             let id = resourceFieldValue.id;
  //             let name = resourceFieldValue.name;
  //             let shortCode = resourceFieldValue.shortCode;
  //                                  

  //             formMethods.setValue(
  //               resourceFieldName,
  //               // '{id:9, name: "Ontario",shortCode:"ON"}'
  //               `{id:${id}, name: "${name}",shortCode:"${shortCode}"}`
  //             );
  //           }
  //           if (resourceFieldName === "provinceOfEmployment") {
  //             let id = resourceFieldValue.id;
  //             let name = resourceFieldValue.name;
  //             let shortCode = resourceFieldValue.shortCode;
  //                                  

  //             formMethods.setValue(
  //               resourceFieldName,
  //               // '{id:9, name: "Ontario",shortCode:"ON"}'
  //               `{id:${id}, name: "${name}",shortCode:"${shortCode}"}`
  //             );
  //         }

  //       });
  //     }
  //     if (fieldName === "slipData") {
  //       Object.keys(fieldValue).forEach((slipDataFieldName) => {
  //         const slipDataFieldValue = fieldValue[slipDataFieldName];
  //         // @ts-ignore
  //         formMethods.setValue(slipDataFieldName, slipDataFieldValue);
  //         
  //       });
  //     }
  //     if (fieldName === "adjustedSlipData") {
  //       Object.keys(fieldValue).forEach((adjustedSlipDataFieldName) => {
  //         const adjustedSlipDataFieldValue =
  //           fieldValue[adjustedSlipDataFieldName];
  //         // @ts-ignore
  //         formMethods.setValue(
  //           adjustedSlipDataFieldName,
  //           adjustedSlipDataFieldValue
  //         );
  //       
  //       });
  //     }

  //     //set slip type according to selected slip for submit button action
  //     if(fieldName === 'slipType'){
  //       selectedSlipTypee = fieldValue
  //       setIsLoadingAdjustedData(true);
  //       setTimeout(() => {
  //         setIsLoadingAdjustedData(false);
  //       }, 1000);
  //     }
  //     if(fieldName === 'otherInformation'){
  //       if(fieldValue.length !== 0){
  //         formMethods.setValue('comparison',fieldValue)
  //       } else{
  //         formMethods.setValue('comparison',[{ amount: 0, code: '', label:''}])
  //       }
  //     }
  //   });
  // }
  // }, [slipRecord, formMethods.setValue, formMethods]);

  //resource info by using selected resource id
  // useEffect(() => {
  //   // if the selected flex field data has loaded.
  //   if (resourceInfo) {
  //     // formMethods.reset();
  //  
  //     Object.keys(resourceInfo).forEach((fieldName) => {
  //       // @ts-ignore
  //       const fieldValue = resourceInfo[fieldName];
  //       
  //       formMethods.setValue(fieldName, fieldValue);

  //       if (fieldName === "address") {
  //         Object.keys(fieldValue).forEach((resourceFieldName) => {
  //           const resourceFieldValue = fieldValue[resourceFieldName];
  //           // @ts-ignore
  //          
  //           // formMethods.setValue(resourceFieldName, resourceFieldValue);
  //           Object.keys(resourceFieldValue).forEach((resourceFieldNameNew) => {
  //             const resourceFieldValueNew =
  //               resourceFieldValue[resourceFieldNameNew];
  //             // @ts-ignore
  //            
  //             formMethods.setValue(resourceFieldNameNew, resourceFieldValueNew);

  //             // if (resourceFieldNameNew === "province") {
  //             //   Object.keys(resourceFieldValueNew).forEach((addressFieldName) => {
  //             //     const addressFieldValue = resourceFieldValueNew[addressFieldName];
  //             //     // @ts-ignore
  //             //     formMethods.setValue(resourceFieldNameNew, addressFieldValue.shortCode ?? undefined);
  //         

  //             //   });
  //             // }
  //             if (resourceFieldNameNew === "country") {
  //               formMethods.setValue(
  //                 resourceFieldNameNew,
  //                 resourceFieldValueNew.name ?? undefined
  //               );
  //             }
  //             if (resourceFieldNameNew === "province") {
  //               let id = resourceFieldValueNew.id;
  //               let name = resourceFieldValueNew.name;
  //               let shortCode = resourceFieldValueNew.shortCode;

  //             

  //               formMethods.setValue(
  //                 resourceFieldNameNew,
  //                 `{id:${id}, name: "${name}",shortCode:"${shortCode}"}`
  //                 // '{id:1, name: "Alberta",shortCode:"AB"}'
  //               );
  //             }
  //           });
  //         });
  //       } else {
  //         // @ts-ignore
  //         formMethods.setValue(fieldName, fieldValue);
  //       }
  //       if(fieldName === 'metaFields'){
  //         fieldValue.forEach((obj:any) => {
  //           formMethods.setValue(obj.name,obj.value)
  //           if(obj.name === 'initial' || obj.name === 'INITIALS'){
  //             formMethods.setValue('initials',obj.value)
  //           }
  //           if(obj.name === 'employee_code'){
  //             formMethods.setValue('employeeCode',obj.value)
  //           }
  //           if(obj.name === 'pay_period'){
  //             formMethods.setValue('payPeriod',obj.value)
  //           }
  //           if(obj.name === 'province_of_employment'){
  //             getPROVINCE_OF_EMPLOYMENT(obj.value)
  //            
  //             if(PROVINCE_OF_EMPLOYMENT !== ''){
  //               formMethods.setValue("provinceOfEmployment",PROVINCE_OF_EMPLOYMENT);
  //             }
  //           }
  //           if(obj.name === 'reduced_ei'){
  //               formMethods.setValue('reducedEi',obj.value)
  //           }
  //           if(obj.name === 'date_of_birth'){
  //             if(obj.value !== ""){
  //             formMethods.setValue('dateOfBirth',obj.value)
  //             if(obj.value.charAt(2) === "*"){
  //               formMethods.setValue('dateOfBirth', obj.value);
  //             setDateOfBirth(obj.value)
  //             }else{
  //               const defaultDate = new Date(obj.value);
  //               formMethods.setValue('dateOfBirth', defaultDate);
  //               setDateOfBirth(formatDate(defaultDate as Date))
  //             }
  //             setDateOfBirthPlaceHolder(obj.value)
  //           }
  //           }
  //           if(obj.name === 'cpp_qpp_exempt'){
  //               formMethods.setValue('cppQppExempt',obj.value)
  //           }
  //           if(obj.name === 'ppip_exempt'){
  //               formMethods.setValue('ppipExempt',obj.value)
  //           }
  //           if(obj.name === 'ei_exempt'){
  //               formMethods.setValue('eiExempt',obj.value)
  //           }
  //           if(obj.name === 'employment_code'){
  //             formMethods.setValue('employmentCode',obj.value)
  //           }
  //          
  //         })
  //       }
  //     });
  //     formMethods.setValue("selectedSlip", "create-new");
  //     formMethods.setValue("applyAdjustments", false);
  //     formMethods.setValue("employmentIncome", "0.00");
  //     formMethods.setValue("cppContributions", "0.00");
  //     formMethods.setValue("eiPremiums", "0.00");
  //     formMethods.setValue("rppContributions", "0.00");
  //     formMethods.setValue("incomeTaxDeducted", "0.00");
  //     formMethods.setValue("eiInsurableEarnings", "0.00");
  //     formMethods.setValue("cppQppPensionableEarnings", "0.00");
  //     formMethods.setValue("unionDues", "0.00");
  //     formMethods.setValue("charitableDonations", "0.00");
  //     formMethods.setValue("registrationNumber", "0.00");
  //     formMethods.setValue("pensionAdjustment", "0.00");
  //     formMethods.setValue("ppipPremiums", "0.00");
  //     formMethods.setValue("ppipInsurableEarnings", "0.00");
  //     formMethods.setValue("employmentIncomeAdjusted", "0.00");
  //     formMethods.setValue("cppContributionsAdjusted", "0.00");
  //     formMethods.setValue("eiPremiumsAdjusted", "0.00");
  //     formMethods.setValue("incomeTaxDeductedAdjusted", "0.00");
  //     formMethods.setValue("eiInsurableEarningsAdjusted", "0.00");
  //     formMethods.setValue("ppipPremiumsAdjusted", "0.00");
  //     formMethods.setValue("ppipInsurableEarningsAdjusted", 0);
  //     formMethods.setValue("slipStatus", 200);
  //     formMethods.setValue('comparison',[{amount:0, code: '', label:''}]);
  //     // formMethods.setValue("reducedEi", 0);
  //     // formMethods.setValue("ppipExempt", false);
  //     // formMethods.setValue("eiExempt", false);
  //     // formMethods.setValue("cppQppExempt", false);
  //     // formMethods.setValue("provinceOfEmployment", null);
  //     // formMethods.setValue("provinceOfEmployment", null);
  //   }
  // }, [resourceInfo, formMethods.setValue, formMethods]);

  // if we have selected the parent and a flex field and they both are the same, we should un-set the parent because a field cannot be the parent of itself
  // useEffect(() => {
  //   if (slipRecord) {
  //     formMethods.setValue("parent", undefined);
  //   }
  // }, [formMethods, slipRecord]);

  // format date to 2023-07-26
  const formatDate = (date: Date): string => {
    return format(date, "yyyy-MM-dd"); // Format the date as "yyyy-MM-dd"
  };

  const onDateOfBirthChangeHandler = (selectedDate: any) => {

    if (selectedDate.value) {

      // alert(formatDate(selectedDate.value as Date));
      setDateOfBirth(formatDate(selectedDate.value as Date));
    } else {
      setDateOfBirth("");
    }
  };



  const onResourceSelectionChangeHandler = async (
    selectedItem: IEnhancedDropDownItem | any,
    index?: any
  ): Promise<void> => {
    //this is for card selection
    setSelectedCard(index);
    setSelectedResourceSlip("create-new");

    // formMethods.setValue("checkbox-eiInsurableEarnings", false);
    // formMethods.setValue("checkbox-cppQppPensionableEarnings", false);

    if (!index) {
      //this is for card selection
      setSelectedCard(selectedItem.value);
      setSelectedResourceSlip("create-new");
    }
    if (selectedItem.value === "create-new") {
      setSnackbarData({
        open: true,
        message: "Please load an employee for T4 Slip",
        severity: "error",
      });
      setSidePanelsVisibility((prevButtonState: any) => !prevButtonState);
      formMethods.setValue("comparison", [{ amount: 0, code: "", label: "" }]);
      formMethods.reset();
      formMethods.setValue("comparison", [{ amount: 0, code: "", label: "" }]);
      setSlipOtherInformation([])
      setDateOfBirth("");
      setDateOfBirthPlaceHolder("");
      setSelectedResourceSlipList([
        { label: "Create New", value: "create-new" },
      ]);
      setSelectedResourceSlip("create-new");
      setSelectedOtherInformation(false);
      let path = `/taxslip/t4/setup`;
      navigate(path);
      setT4SlipRecord(undefined);
      setSelectedResource("create-new");
    } else {
      // formMethods.reset();
      setOnResourceSelectionAPIsCalls(true);
      formMethods.setValue(
        "selectedEmployee",
        selectedItem.value
      );
      setSelectedResource(selectedItem.value);
      (async () => {
        setIsPendingSlipData(true);
        try {
          const response: any =
            await T4SlipService.getResourceSlipDropDownList(
              selectedItem.value,
              clientId,
              taxYear
            );

          // formMethods.setValue("selectedSlip", response[0].value);

          if (response && Array.isArray(response)) {
            let resourceSlipList: IDropDownListResponse[] =
              response.map(
                (resourceSlip: IDropDownListResponse) => ({
                  label: resourceSlip.label,
                  value: resourceSlip.value,
                })
              );

            resourceSlipList.unshift({
              label: "Create New",
              value: "create-new",
            });


            setSelectedResourceSlipList(resourceSlipList);
            if (
              resourceSlipList &&
              resourceSlipList.length > 1
            ) {
              (async () => {
                setIsPendingSlipData(true);
                try {
                  let slipDataById =
                    await T4SlipService.getT4SlipById(
                      String(resourceSlipList[1].value),
                      clientId,
                      taxYear
                    );
                  setT4SlipRecord(slipDataById)
                  setSelectedResourceSlip(
                    String(resourceSlipList[1].value)
                  );
                  formMethods.setValue(
                    "selectedSlip",
                    String(resourceSlipList[1].value)
                  );
                  slipDataByIdPass(slipDataById, true);
                  selectedSlipTypee =
                    formMethods.getValues("slipType");
                  setSelectedOtherInformation(false);
                } catch (error) {
                  setIsPendingSlipData(false);
                  console.error(
                    "Error fetching data:",
                    error
                  );
                }
              })();
            } else {
              (async () => {
                try {
                  setIsPendingSlipData(true);
                  let resourceDataById =
                    await T4SlipService.getResourceInformationById(
                      selectedItem.value,
                      clientId,
                      "Employee"
                    );
                  resourceDataByIdPass(resourceDataById)
                } catch (error) {
                  setIsPendingSlipData(false)
                  console.error("Error fetching data:", error);
                }
              })();
              setT4SlipRecord(undefined)
              setSelectedResourceSlip("create-new");
              setSelectedResource(String(selectedItem.value));
              setEditedResourceId(String(selectedItem.value));
              let path = `/taxslip/t4/setup/${selectedItem.value}`;
              navigate(path);
            }
          }
        } catch (error) {
          setIsPendingSlipData(false);
          console.error("Error fetching data:", error);
        }
      })();
    }
    setSelectedOtherInformation(false);
  };

  const onResourceSlipSelectionChangeHandler = (
    selectedItem: IEnhancedDropDownItem | any
  ) => {

    setOnResourceSelectionAPIsCalls(true)
    if (selectedItem.value === "create-new") {
      createNewActionFromSlipDDL();
      setT4SlipRecord(undefined);
      setSelectedResourceSlip("create-new");
      if (selectedResource !== "create-new") {
        setOnResourceSelectionAPIsCalls(false);
        let path = `/taxslip/t4/setup/${selectedResource}`;
        navigate(path);
      }
    }
    if (selectedItem.value !== "create-new") {
      (async () => {
        try {
          setIsLoadingAdjustedData(true);
          let slipDataById = await T4SlipService.getT4SlipById(
            String(selectedItem.value),
            clientId,
            taxYear
          );
          setT4SlipRecord(slipDataById)
          slipDataByIdPass(slipDataById, true);
          selectedSlipTypee = formMethods.getValues("slipType");
          setSelectedOtherInformation(false);
          setIsLoadingAdjustedData(false);
        } catch (error) {
          setIsLoadingAdjustedData(false);
          console.error("Error fetching data:", error);
        }
      })();
    }
    //otherinformation will update selected items
    setSelectedOtherInformation(true);
  };

  // for edit

  //if slip is completed this will effected
  //if dob is masked then placeholder change
  const [dateOfBirthPlaceHolder, setDateOfBirthPlaceHolder] = useState("");

  // let selectedPOEwhenUpdate = "";
  useEffect(() => {
    if (T4SlipRecord && onResourceSelectionAPIsCalls === false) {
      slipDataByIdPass(T4SlipRecord, onResourceSelectionAPIsCalls);
    }
    selectedSlipTypee = formMethods.getValues("slipType");
    setSelectedOtherInformation(false);

    if (!id && !T4SlipRecord && dashboardApiData && dashboardApiData.default_setting && dashboardApiData.default_setting.t4DefaultSetting) {

      defaultSettingsCalls()
    } else if (!id && !T4SlipRecord && dashboardApiData && dashboardApiData.default_setting && dashboardApiData.default_setting.message) {

      formMethods.setValue("comparison", [
        { amount: 0, code: "", label: "" },
      ]);
    }
  }, [T4SlipRecord, formMethods.setValue, formMethods, dashboardApiData, id, onResourceSelectionAPIsCalls]);

  //this is for not started slip
  useEffect(() => {
    if (
      selectedNotStartedResourceData &&
      onResourceSelectionAPIsCalls === false
    ) {
      resourceDataByIdPass(selectedNotStartedResourceData);
    }

  }, [selectedNotStartedResourceData, formMethods.setValue, formMethods, onResourceSelectionAPIsCalls]);

  // apply Adjustment

  const [adjustedDataResponse, setAdjustedDataResponse] = useState(undefined);
  const onSelectionChange: any = async (e: any) => {
    // alert(e);
    // setAdjustment(e);

    const jsonString = formMethods.getValues("provinceOfEmployment")
      ? formMethods.getValues("provinceOfEmployment")
      : ('{id:9, name: "Ontario",shortCode:"ON"}' as string);

    // Custom parsing function to convert the JSON-like string to an object
    const parseJSONLikeString = (str: string) => {
      // Use regular expressions to add double quotes around keys and string values
      const modifiedString = str.replace(/(\w+):/g, '"$1":').replace(/'/g, '"');

      // Convert the modified JSON string to an object using JSON.parse()
      return JSON.parse(modifiedString);
    };

    // Convert the JSON-like string to an object
    const myObject = parseJSONLikeString(jsonString);



    const payload = {
      clientId: clientId,
      taxYear: taxYear,
      slipId:
        selectedT4SlipsData && selectedT4SlipsData.resource
          ? selectedT4SlipsData.id
          : T4SlipRecord && T4SlipRecord.id ? T4SlipRecord.id
            : undefined,
      applyAdjustments: true,
      saveAdjutments: false,
      pensionablePeriod: parseInt(formMethods.getValues("pensionablePeriod")),
      slipType: formMethods.getValues("slipType"),
      resource: {
        externalId:
          selectedT4SlipsData && selectedT4SlipsData.resource
            ? selectedT4SlipsData.resource.externalId
            : selectedNotStartedResourceData &&
              selectedNotStartedResourceData.id
              ? selectedNotStartedResourceData.id
              : undefined,
        dateOfBirth:
          dateOfBirth.charAt(2) === "*"
            ? undefined
            :
            dateOfBirth !== "" || null
              ? dateOfBirth
              : undefined,
        // provinceOfEmployment:
        //   formMethods.getValues("provinceOfEmployment") !== undefined
        //     ? formMethods.getValues("provinceOfEmployment")
        //     : { id: 9, name: "Ontario", shortCode: "ON" },
        provinceOfEmployment: myObject,
        cppQppExempt: formMethods.getValues("cppQppExempt"),
        eiExempt: formMethods.getValues("eiExempt"),
        ppipExempt: formMethods.getValues("ppipExempt"),
        payPeriod: formMethods.getValues("payPeriod"),
      },
      slipData: {
        employmentIncome: Number(formMethods.getValues("employmentIncome").replace(/[$,]/g, '')),
        cppContributions: formMethods.getValues("cppContributions") && formMethods.getValues("cppContributions") !== null ? parseFloat(formMethods.getValues("cppContributions").replace(/[$,]/g, '')) : 0,
        secondCppContributions: taxYear > 2023 && formMethods.getValues("secondCppContributions") && formMethods.getValues("secondCppContributions") !== null
          ? parseFloat(formMethods.getValues("secondCppContributions").replace(/[$,]/g, '')) : 0,
        qppContributions: formMethods.getValues("qppContributions") && formMethods.getValues("qppContributions") !== null ? parseFloat(formMethods.getValues("qppContributions").replace(/[$,]/g, '')) : 0,
        secondQppContributions: taxYear > 2023 && formMethods.getValues("secondQppContributions") && formMethods.getValues("secondQppContributions") !== null
          ? parseFloat(formMethods.getValues("secondQppContributions").replace(/[$,]/g, '')) : 0,
        eiPremiums: formMethods.getValues("eiPremiums") && formMethods.getValues("eiPremiums") !== null ? parseFloat(formMethods.getValues("eiPremiums").replace(/[$,]/g, '')) : 0,
        // rppContributions:parseFloat(formMethods.getValues('rppContributions')),
        incomeTaxDeducted: formMethods.getValues("incomeTaxDeducted") && formMethods.getValues("incomeTaxDeducted") !== null ? parseFloat(
          formMethods.getValues("incomeTaxDeducted").replace(/[$,]/g, '')
        ) : 0,
        eiInsurableEarnings: formMethods.getValues("eiInsurableEarnings") && formMethods.getValues("eiInsurableEarnings") !== null ? parseFloat(
          formMethods.getValues("eiInsurableEarnings").replace(/[$,]/g, '')
        ) : 0,
        cppQppPensionableEarnings: formMethods.getValues("cppQppPensionableEarnings") && formMethods.getValues("cppQppPensionableEarnings") !== null ? parseFloat(
          formMethods.getValues("cppQppPensionableEarnings").replace(/[$,]/g, '')
        ) : 0,
        // unionDues:parseFloat(formMethods.getValues('unionDues')),
        // charitableDonations:parseFloat(formMethods.getValues('charitableDonations')),
        // registrationNumber:parseFloat(formMethods.getValues('registrationNumber')),
        // pensionAdjustment:parseFloat(formMethods.getValues('pensionAdjustment')),
        ppipPremiums: formMethods.getValues("ppipPremiums") && formMethods.getValues("ppipPremiums") !== null ? parseFloat(formMethods.getValues("ppipPremiums").replace(/[$,]/g, '')) : 0,
        ppipInsurableEarnings: formMethods.getValues("ppipInsurableEarnings") && formMethods.getValues("ppipInsurableEarnings") !== null ? parseFloat(
          formMethods.getValues("ppipInsurableEarnings").replace(/[$,]/g, '')
        ) : 0,
      },
      adjustedSlipData: {
        // employmentIncomeAdjusted: parseFloat("2.22"),
        // cppContributionsAdjusted: parseFloat("2.22"),
        // qppContributions: parseFloat("0.00"),
        // eiPremiumsAdjusted: parseFloat("2.22"),
        // incomeTaxDeductedAdjusted: parseFloat("2.22"),
        // eiInsurableEarningsAdjusted: parseFloat("2.22"),
        // ppipPremiumsAdjusted: parseFloat("2.22"),
        // ppipInsurableEarningsAdjusted: parseFloat("2.22"),
      },
    };

    if (e === true) {
      try {
        setIsLoadingAdjustedData(true);
        const response = await T4SlipService.getAdjustedData(payload);
        if (response) {
          Object.keys(response).forEach((fieldName) => {
            // @ts-ignore
            const fieldValue = response[fieldName];
            if (fieldName === "adjustedSlipData") {
              Object.keys(fieldValue).forEach((adjustedSlipDataFieldName) => {
                const adjustedSlipDataFieldValue =
                  fieldValue[adjustedSlipDataFieldName];
                // @ts-ignore
                formMethods.setValue(
                  adjustedSlipDataFieldName,
                  parseFloat(adjustedSlipDataFieldValue).toFixed(2)
                );

              });
            }
          });
        }
        // setAdjustedDataResponse(response);
      } catch (err) {

        // alert(err)
      } finally {
        setIsLoadingAdjustedData(false);
      }
    }
    if (e === false) {
      formMethods.setValue("employmentIncomeAdjusted", "0.00");
      formMethods.setValue("cppContributionsAdjusted", "0.00");
      formMethods.setValue("secondCppContributionsAdjusted", "0.00");
      formMethods.setValue("qppContributionsAdjusted", "0.00");
      formMethods.setValue("secondQppContributionsAdjusted", "0.00");
      formMethods.setValue("eiPremiumsAdjusted", "0.00");
      formMethods.setValue("incomeTaxDeductedAdjusted", "0.00");
      formMethods.setValue("eiInsurableEarningsAdjusted", "0.00");
      formMethods.setValue("ppipPremiumsAdjusted", "0.00");
      formMethods.setValue("ppipInsurableEarningsAdjusted", "0.00");
    }
  };

  useEffect(() => {

    if (
      slipOtherInformation &&
      slipOtherInformation !== null &&
      slipOtherInformation.length !== 0
    ) {

      setOiInEdit(true);
      formMethods.setValue(
        "comparison",
        slipOtherInformation
      );
    } else if (!id) {
      defaultSettingsCalls()
    }
  }, [slipOtherInformation])

  const onSlipTypeSelectionChangeHandler = (e: any) => {
    setIsLoadingAdjustedData(true);
    setTimeout(() => {
      setIsLoadingAdjustedData(false);
    }, 1000);
    const selectedType = e.value;
    selectedSlipTypee = selectedType;
    // alert(selectedType);
  };

  const onCloseHandler = () => {
    setDialogOpen(false);
    setInvoiceDialogOpen(false);
  };

  // console.log("selectedCard--", selectedCard);

  const getCardStyles = (index: any) => {

    return {
      borderLeft:
        selectedCard === index ? "6px solid #0057db" : "2px solid transparent",
      cursor: "pointer",
    };
  };
  const getSelectedResourceSlipInCard = (index: any) => {
    let selectedItem =
      selectedCard === index ? selectedResourceSlip : "create-new";
    return selectedItem;
  };
  const getSelectedResourceSlipsListInCard = (index: any) => {
    let selectedList =
      selectedCard === index
        ? selectedResourceSlipList
        : [{ label: "Create New", value: "create-new" }];
    return selectedList;
  };

  const filteredResourceList =
    resourceListWithoutCreateNew &&
    resourceListWithoutCreateNew.filter((item: any) =>
      item.label.toLowerCase().includes(itemSearch.toLowerCase())
    );

  const onCreateNewButtonClicked = () => {
    formMethods.reset();
    formMethods.setValue("comparison", [{ amount: 0, code: "", label: "" }]);
    setSlipOtherInformation([])
    formMethods.setValue("employmentIncome", '0.00');
    setDateOfBirth("");
    setDateOfBirthPlaceHolder("");
    setSelectedResourceSlipList([{ label: "Create New", value: "create-new" }]);
    setSelectedResourceSlip("create-new");
    setSelectedOtherInformation(false);
    let path = `/taxslip/t4/setup`;
    navigate(path);
    setT4SlipRecord(undefined);
    setSelectedOtherInformation(false);
    setSelectedResource("create-new");
    setSelectedCard(null);
    defaultSettingsCalls()

    //because of issue in slipdata values not clear issue
    window.location.reload()
  };
  const onDividerButtonClickHandler = () => {
    setSidePanelsVisibility((prevButtonState: any) => !prevButtonState);
  };

  useEffect(() => {
    dispatch(
      setSelectedActivityLogActions({
        entityId1: id ? id : "",
        entityId2: "",
        entityId3: "",
        screenName: T4_SETUP_SCREEN_SLUG,
        companyName: clientName,
        activityType: "activity_type=create&activity_type=updated&activity_type=delete&activity_type=print",
        activityLogVisibility: true,
      })
    );
    dispatch(setSelectedStickyNavBar({ isSticky: true }));
  }, []);
  return (
    <>
      <Grid
        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
        sx={{
          pb: "5rem",
          "& .MuiAppBar-root": { zIndex: 2, top: "65px" },
          "& .p-datepicker": { zIndex: 2 },
          paddingTop: "2rem",
        }}
      >
        <BackdropCircularProgress
          open={
            // isLoadingDropDownList ||
            // isLoadingResourceSlips ||
            // isLoadingSlipData ||
            isSubmitting ||
            isLoadingData ||
            // isLoadingResourceInfo ||
            // reFetchingSlipData ||
            isLoadingAdjustedData ||
            // isLoadingProvinceDropDownList ||
            isLoadingSlipListDDL ||
            isLoadingNotStartedSlipId ||
            isDeleting ||
            isLoadingNotStartedSlipId ||
            isLoadingDataa ||
            // isLoadingGlobalVariables ||
            isLoadingActivityLogData ||
            // isLoadingDefaultSettingsData ||
            // isLoadingT4OtherInformationList
            isPendingSlipData
          }
          testId={testId}
        />
        <DeleteConfirmationDialog
          open={openDialog}
          deleteActionHandler={deleteT4SlipField}
          cancelActionHandler={onCloseHandler}
          testId="T4-confirmation-dialog"
        />
        <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
          {sidePanelsVisibility && (
            <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
              <Box sx={{ margin: "0" }}>
                <InputText
                  value={itemSearch}
                  onChange={(e) => setItemSearch(e.target.value)}
                  placeholder={"Search by name..."}
                  className="w-full search-field"
                />
                <Box sx={{ display: "flex", justifyContent: "end" }}>
                  <Button
                    variant="contained"
                    sx={{ right: 0, margin: "10px 0px", fontSize: "12px" }}
                    onClick={onCreateNewButtonClicked}
                  >
                    + Create New
                  </Button>
                </Box>
              </Box>
              <Box
                sx={{
                  // display: "flex",
                  height: "95rem",
                  // flexDirection: "column",
                  overflow: "auto",
                  "&::-webkit-scrollbar": {
                    width: "0.4em",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#ccc",
                    borderRadius: "3px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#aaa",
                  },
                }}
              >
                {resourceListWithoutCreateNew &&
                  filteredResourceList.map((item: any, index: any) => {
                    return (
                      <Card
                        sx={{
                          padding: 0,
                          borderRadius: "8px",
                          marginBottom: "1rem",
                        }}
                        key={index}
                        onClick={() =>
                          onResourceSelectionChangeHandler(item, item.value)
                        }
                        style={getCardStyles(item.value)}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "0.8rem",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{ fontWeight: "bold", fontSize: ".875rem" }}
                          >
                            {item.label}
                          </Typography>
                          <Avatar
                            shape="circle"
                            style={{
                              background: "#0057db",
                              color: "#fff",
                              borderRadius: "50%",
                              fontWeight: "bold",
                              fontSize: ".775rem",
                              padding: "2px",
                            }}
                          >
                            {item.label
                              .replace(/\s+/g, " ")
                              .split(" ")
                              .filter((word: string) => word.trim() !== "")
                              .map((word: string) => word[0].toUpperCase())
                              .slice(0, 2)
                              .join("")}
                          </Avatar>
                        </Box>
                        {selectedCard === item.value ? (
                          <>
                            <Divider className="m-0" />
                            <Box>
                              <Box sx={{ padding: "0.6rem" }}>
                                <Dropdown
                                  value={getSelectedResourceSlipInCard(
                                    item.value
                                  )}
                                  onChange={
                                    onResourceSlipSelectionChangeHandler
                                  }
                                  options={getSelectedResourceSlipsListInCard(
                                    item.value
                                  )}
                                  onClick={(e: any) => e.stopPropagation()}
                                  className="slip-dropdown"
                                />
                              </Box>
                            </Box>
                          </>
                        ) : (
                          <></>
                        )}
                      </Card>
                    );
                  })}
              </Box>
            </Grid>
          )}
          <Divider
            layout="vertical"
            align="center"
            className="verticle-divider"
            style={{ zIndex: 0 }}
          >
            <Button
              variant="outlined"
              sx={{
                minWidth: "fit-content",
                padding: "20px 0",
                borderRadius: "7px",
              }}
              onClick={onDividerButtonClickHandler}
            >
              {sidePanelsVisibility ? (
                <i
                  className="pi pi-angle-double-left"
                  style={{ color: "#0057db" }}
                ></i>
              ) : (
                <i
                  className="pi pi-angle-double-right"
                  style={{ color: "#0057db" }}
                ></i>
              )}
            </Button>
          </Divider>
          <Grid
            size={{
              xs: sidePanelsVisibility ? 8 : 10,
              sm: sidePanelsVisibility ? 8 : 10.8,
              md: sidePanelsVisibility ? 9.4 : 11.2,
              lg: sidePanelsVisibility ? 9.5 : 11.6,
              xl: sidePanelsVisibility ? 9.7 : 11.7
            }}
            sx={{ "& .MuiGrid-container": { marginTop: 0 } }}
          >
            <FormProvider {...formMethods}>
              <form onSubmit={formMethods.handleSubmit(onSubmit)}>
                <TwoColumnLayout
                  toolbar={
                    <T4SlipSetupToolbar
                      onResetClicked={onResetClicked}
                      onDeleteClicked={onDeleteClicked}
                      onPrintClicked={onPrintClicked}
                      isSubmitting={isSubmitting}
                      formMethods={formMethods}
                      t4SummaryData={dashboardApiData.t4_summary}
                      t4SummaryReduceEIData={dashboardApiData.t4_summary_reduce_ei}
                    />
                  }
                  leftColumnContent={
                    <>
                      {!sidePanelsVisibility && (
                        <StandardPanel
                          title="Load Slips"
                          testId={`${testId}-load-slips-panel`}
                        >
                          <Grid
                            container
                            columnSpacing={2}
                            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                          >
                            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                              <EnhancedDropDownRHFWithLabel
                                label="Load Employee"
                                selectName="selectedEmployee"
                                items={selectedResourceList}
                                selectedItem={selectedResource}
                                testId="selected-employee"
                                onSelectionChangeHandler={
                                  onResourceSelectionChangeHandler
                                }
                              // isLoading={isLoadingFlexFieldsList}
                              />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                              <EnhancedDropDownRHFWithLabel
                                label="Load T4 Slip"
                                selectName="selectedSlip"
                                items={selectedResourceSlipList}
                                selectedItem={selectedResourceSlip}
                                testId="selected-slip"
                                onSelectionChangeHandler={
                                  onResourceSlipSelectionChangeHandler
                                }
                              // isLoading={isLoadingFlexFieldsList}
                              />
                            </Grid>
                          </Grid>
                        </StandardPanel>
                      )}
                      <StandardPanel
                        title="Slip Data"
                        testId={`${testId}-slip-data`}
                        topPadding={!sidePanelsVisibility ? 2 : 0}
                      >
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                          <EnhancedIOSSwitchRHFWithLabel
                            name="applyAdjustments"
                            checked={false}
                            testId="applyAdjustments"
                            label="Apply Adjustments"
                            labelPosition={LabelPosition.Left}
                            labelColumns={6}
                            fieldColumns={6}
                            onSelectionChangeHandler={onSelectionChange}
                          />
                        </Grid>
                        {T4OtherInformationList && (
                          <T4SlipDataPanel
                            formMethods={formMethods}
                            isLoading={false}
                            otherInformationList={T4OtherInformationList}
                            testId={testId}
                            selectedOtherInformation={selectedOtherInformation}
                            oiInEdit={oiInEdit}
                            selectedProvinceOfEmployment={
                              selectedProvinceOfEmployment
                            }
                            globalVariablesData={
                              dashboardApiData.global_variable
                            }
                            T4SlipRecord={T4SlipRecord}
                          />
                        )}
                      </StandardPanel>
                    </>
                  }
                  rightColumnContent={
                    <>
                      <StandardPanel
                        title="Employee Info"
                        testId={`${testId}-employee-info`}
                      >
                        <EmployeeInfoSetupFieldsPanel
                          onDateOfBirthChangeHandler={
                            onDateOfBirthChangeHandler
                          }
                          testId={testId}
                        />
                        {/* <FieldWrapper>
                          <FieldLayout
                            label="Date of Birth"
                            // isRequired={isRequired}
                            testId={testId}
                            labelPosition={LabelPosition.Left}
                            labelColumns={4}
                            fieldColumns={8}
                          >
                            <Calendar
                              id="dateOfBirth"
                              {...formMethods.register("dateOfBirth")} // Register the input with react-hook-form using methods.register
                              value={formMethods.watch("dateOfBirth") || null} // Set the value using watch to reflect changes
                              showIcon
                              // dateFormat="dd/mm/yy" // Customize the date format as needed
                              placeholder={
                                dateOfBirthPlaceHolder !== "" ||
                                  dateOfBirthPlaceHolder.charAt(2) === "*"
                                  ? "Unmask to view / edit"
                                  : "dd/mm/yyyy"
                              }
                              disabled={
                                dateOfBirthPlaceHolder !== "" &&
                                dateOfBirthPlaceHolder.charAt(2) === "*"
                              } //if unmask then it is enabled
                              // className="w-full"
                              style={{ height: "2.6rem" }}
                              onChange={onDateOfBirthChangeHandler}
                              dateFormat="M dd, yy"
                              required={dashboardApiData.default_setting && !dashboardApiData.default_setting.message && dashboardApiData.default_setting.fillingDataAttribute.employeeDobIsRequired}
                              // invalid={true}
                              className={`w-full ${dashboardApiData.default_setting && !dashboardApiData.default_setting.message && dashboardApiData.default_setting.fillingDataAttribute.employeeDobIsRequired && dateOfBirth === '' ? 'p-invalid' : ''}`}
                            />
                            {dashboardApiData.default_setting && !dashboardApiData.default_setting.message && dashboardApiData.default_setting.fillingDataAttribute.employeeDobIsRequired && dateOfBirth === '' ? <small className="p-error" style={{ paddingLeft: "1rem" }}>Date is required.</small> : <></>}
                          </FieldLayout>
                        </FieldWrapper> */}


                        <T4DOBCalendar
                          name={"dateOfBirth1"}
                          placeholder={
                            dateOfBirthPlaceHolder !== "" ||
                              dateOfBirthPlaceHolder.charAt(2) === "*"
                              ? "Unmask to view / edit"
                              : "dd/mm/yyyy"
                          }
                          disabled={
                            dateOfBirthPlaceHolder !== "" &&
                            dateOfBirthPlaceHolder.charAt(2) === "*"
                          }
                          required={dashboardApiData.default_setting && !dashboardApiData.default_setting.message && dashboardApiData.default_setting.fillingDataAttribute.employeeDobIsRequired}
                          className={`w-full ${dashboardApiData.default_setting && !dashboardApiData.default_setting.message && dashboardApiData.default_setting.fillingDataAttribute.employeeDobIsRequired && dateOfBirth === '' ? 'p-invalid' : ''}`}
                          helperText={dashboardApiData.default_setting && !dashboardApiData.default_setting.message && dashboardApiData.default_setting.fillingDataAttribute.employeeDobIsRequired && dateOfBirth === '' ? "Date of birth is required." : ""}
                          onChangeHandler={onDateOfBirthChangeHandler}
                          label={"Date of Birth"}
                        />






                      </StandardPanel>
                      <StandardPanel
                        title="Address"
                        testId={`${testId}-employee-address-panel`}
                        topPadding={2}
                      >
                        <EmployeeAddressSetupFieldsPanel testId={testId} />
                        {/* <EnhancedDropDownRHFWithLabel
                        selectName="province"
                        label="Province"
                        // selectedItem={selectedProvince.id !== null && selectedProvince}
                        labelPosition={LabelPosition.Left}
                        required
                        testId={`${testId}-province-list`}
                        items={provinceList ?? []}
                        onSelectionChangeHandler={onProvinceSelectionChangeHandler}
                      /> */}
                      </StandardPanel>
                      <StandardPanel
                        title="Filing Data"
                        testId={`${testId}-filing-data-panel`}
                        topPadding={2}
                      >
                        <EnhancedDropDownRHFWithLabel
                          label="Slip Type"
                          selectName="slipType"
                          items={[
                            { label: "Original", value: 400 },
                            { label: "Amended", value: 200 },
                            { label: "Cancelled", value: 300 },
                            { label: "Additional", value: 100 },
                          ]}
                          selectedItem={400}
                          testId="slip-type"
                          labelPosition={LabelPosition.Left}
                          required
                          onSelectionChangeHandler={
                            onSlipTypeSelectionChangeHandler
                          }
                        />
                        <FilingDataSetupFieldsPanel
                          formMethods={formMethods}
                          onPOEchange={(value) =>
                            setSelectedProvinceOfEmployment(value)
                          }
                          showbox17IfQC={showbox17IfQC}
                          globalVariablesData={
                            dashboardApiData.global_variable
                          }
                          clientDataById={
                            dashboardApiData.client_detail
                          }
                        />
                      </StandardPanel>
                    </>
                  }
                  testId="t4-slip-setup-form"
                />
              </form>
            </FormProvider>
          </Grid>
        </Grid>
        {/* invoice dialogu open if any transaction is unPaid */}
        <EnhancedDialog
          dialogTitle="Invoice(s) Due"
          key="dialog-box-1"
          testId="dialog"
          onCloseHandler={onCloseHandler}
          open={openInvoiceDialog}
          dialogContent={
            <InvoiceDialogPanel
              invoiceData={invoiceData}
              onUnPaidClickHandler={onUnPaidClickHandler}
              onClickInvoiceNoHandler={onClickInvoiceNoHandler}
            />
          }
          dialogAction={
            <Grid>
              <Button autoFocus variant="contained" onClick={onCloseHandler}>
                Cancel
              </Button>
            </Grid>
          }
        />
        <EnhancedSnackbar
          message={snackbarData.message}
          onCloseHandler={onSnackbarClosed}
          severity={snackbarData.severity}
          testId={`${testId}-snackbar`}
          open={snackbarData.open}
          autoHide={snackbarData.autoHide}
        />
      </Grid>
    </>
  );
};
